// This file is automatically @generated by scripts/generate-json-schema/index.ts

export const topLevelSchemas = {
  arrowPostProjectDraft: {
    anyOf: [
      { $ref: 'defs.json#/definitions/ArrowPostJobFormState' },
      { type: 'null' },
    ],
  },
  developersPreference: {
    anyOf: [
      { $ref: 'defs.json#/definitions/DevelopersPreference' },
      { type: 'null' },
    ],
  },
  postProjectObject: {
    anyOf: [
      { $ref: 'defs.json#/definitions/ProjectViewProject' },
      { type: 'null' },
    ],
  },
  projectOverlayThreadComplete: {
    type: 'object',
    additionalProperties: false,
    patternProperties: { '^[0-9]+$': { type: 'boolean' } },
  },
  projectOverlayFullFlowComplete: { type: 'boolean' },
  webappChats: {
    type: 'array',
    items: {
      type: 'object',
      properties: {
        minimised: { type: 'boolean' },
        focus: { $ref: 'defs.json#/definitions/FocusState' },
        width: { type: 'number' },
        height: { type: 'number' },
        threadIdentifier: { $ref: 'defs.json#/definitions/ThreadIdentifier' },
      },
      required: ['focus', 'height', 'minimised', 'threadIdentifier', 'width'],
    },
  },
  webappChatDraftMessages: {
    type: 'object',
    additionalProperties: {
      anyOf: [
        { $ref: 'defs.json#/definitions/DraftMessage' },
        { type: 'null' },
      ],
    },
  },
  webappThreadListMinimise: { type: 'boolean' },
  contestShowSocialShareBanner: {
    type: 'object',
    additionalProperties: false,
    patternProperties: { '^[0-9]+$': { type: 'boolean' } },
  },
  taskList: {
    anyOf: [{ $ref: 'defs.json#/definitions/TaskListState' }, { type: 'null' }],
  },
  taskListCurrentTaskClean: { type: ['null', 'boolean'] },
  lastSeenPjpAssistant: { $ref: 'defs.json#/definitions/LastSeenPjpAssistant' },
  hireMeDraft: {
    anyOf: [{ $ref: 'defs.json#/definitions/HireMeDraft' }, { type: 'null' }],
  },
  navUpdatesLastReadTime: { type: ['null', 'number'] },
  dashboardMyProjectsUserType: {
    anyOf: [
      { enum: ['employer', 'freelancer'], type: 'string' },
      { type: 'null' },
    ],
  },
  enterpriseContactFormSubmitted: { type: 'boolean' },
  postJobPageDraft: {
    anyOf: [
      { $ref: 'defs.json#/definitions/PostJobPageFormState' },
      { type: 'null' },
    ],
  },
  manageRecentTable: {
    anyOf: [
      { $ref: 'defs.json#/definitions/ManageRecentTable' },
      { type: 'null' },
    ],
  },
  inviteToBidDiscardedFreelancers: {
    type: 'object',
    additionalProperties: false,
    patternProperties: {
      '^[0-9]+$': { type: 'array', items: { type: 'number' } },
    },
  },
  testProperty: { type: 'number' },
  testName: { type: ['null', 'string'] },
  testProfile: { $ref: 'defs.json#/definitions/MockProfile' },
};

export const definitions = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  definitions: {
    LocalStorageTypes: {
      description:
        'Holds the types which can be stored in local storage i.e. are JSON serialisable.\nValues can be restricted to solely their type,\nor can also be allowed to be `null` (if the item needs to be able to be deleted).',
      type: 'object',
      properties: {
        arrowPostProjectDraft: {
          anyOf: [
            { $ref: 'defs.json#/definitions/ArrowPostJobFormState' },
            { type: 'null' },
          ],
        },
        developersPreference: {
          anyOf: [
            { $ref: 'defs.json#/definitions/DevelopersPreference' },
            { type: 'null' },
          ],
        },
        postProjectObject: {
          anyOf: [
            { $ref: 'defs.json#/definitions/ProjectViewProject' },
            { type: 'null' },
          ],
        },
        projectOverlayThreadComplete: {
          type: 'object',
          additionalProperties: false,
          patternProperties: { '^[0-9]+$': { type: 'boolean' } },
        },
        projectOverlayFullFlowComplete: { type: 'boolean' },
        webappChats: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              minimised: { type: 'boolean' },
              focus: { $ref: 'defs.json#/definitions/FocusState' },
              width: { type: 'number' },
              height: { type: 'number' },
              threadIdentifier: {
                $ref: 'defs.json#/definitions/ThreadIdentifier',
              },
            },
            required: [
              'focus',
              'height',
              'minimised',
              'threadIdentifier',
              'width',
            ],
          },
        },
        webappChatDraftMessages: {
          type: 'object',
          additionalProperties: {
            anyOf: [
              { $ref: 'defs.json#/definitions/DraftMessage' },
              { type: 'null' },
            ],
          },
        },
        webappThreadListMinimise: { type: 'boolean' },
        contestShowSocialShareBanner: {
          type: 'object',
          additionalProperties: false,
          patternProperties: { '^[0-9]+$': { type: 'boolean' } },
        },
        taskList: {
          anyOf: [
            { $ref: 'defs.json#/definitions/TaskListState' },
            { type: 'null' },
          ],
        },
        taskListCurrentTaskClean: { type: ['null', 'boolean'] },
        lastSeenPjpAssistant: {
          $ref: 'defs.json#/definitions/LastSeenPjpAssistant',
        },
        hireMeDraft: {
          anyOf: [
            { $ref: 'defs.json#/definitions/HireMeDraft' },
            { type: 'null' },
          ],
        },
        navUpdatesLastReadTime: { type: ['null', 'number'] },
        dashboardMyProjectsUserType: {
          anyOf: [
            { enum: ['employer', 'freelancer'], type: 'string' },
            { type: 'null' },
          ],
        },
        enterpriseContactFormSubmitted: { type: 'boolean' },
        postJobPageDraft: {
          anyOf: [
            { $ref: 'defs.json#/definitions/PostJobPageFormState' },
            { type: 'null' },
          ],
        },
        manageRecentTable: {
          anyOf: [
            { $ref: 'defs.json#/definitions/ManageRecentTable' },
            { type: 'null' },
          ],
        },
        inviteToBidDiscardedFreelancers: {
          type: 'object',
          additionalProperties: false,
          patternProperties: {
            '^[0-9]+$': { type: 'array', items: { type: 'number' } },
          },
        },
        testProperty: { type: 'number' },
        testName: { type: ['null', 'string'] },
        testProfile: { $ref: 'defs.json#/definitions/MockProfile' },
      },
      required: [
        'arrowPostProjectDraft',
        'contestShowSocialShareBanner',
        'dashboardMyProjectsUserType',
        'developersPreference',
        'enterpriseContactFormSubmitted',
        'hireMeDraft',
        'inviteToBidDiscardedFreelancers',
        'lastSeenPjpAssistant',
        'manageRecentTable',
        'navUpdatesLastReadTime',
        'postJobPageDraft',
        'postProjectObject',
        'projectOverlayFullFlowComplete',
        'projectOverlayThreadComplete',
        'taskList',
        'taskListCurrentTaskClean',
        'testName',
        'testProfile',
        'testProperty',
        'webappChatDraftMessages',
        'webappChats',
        'webappThreadListMinimise',
      ],
    },
    BidApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        bidder_id: { type: 'number' },
        project_id: { type: 'number' },
        retracted: { type: 'boolean' },
        amount: { type: 'number' },
        period: { type: 'number' },
        description: { type: 'string' },
        project_owner_id: { type: 'number' },
        submitdate: { type: 'number' },
        buyer_project_fee: { $ref: 'defs.json#/definitions/FeeApi' },
        time_submitted: { type: 'number' },
        highlighted: { type: 'boolean' },
        sponsored: { type: 'number' },
        milestone_percentage: { type: 'number' },
        award_status_possibilities: {
          type: 'array',
          items: {
            enum: ['awarded', 'canceled', 'pending', 'rejected', 'revoked'],
            type: 'string',
          },
        },
        award_status: {
          enum: ['awarded', 'canceled', 'pending', 'rejected', 'revoked'],
          type: 'string',
        },
        paid_status: {
          enum: ['fully_paid', 'partly_paid', 'unpaid'],
          type: 'string',
        },
        complete_status: {
          enum: ['complete', 'incomplete', 'pending'],
          type: 'string',
        },
        reputation: { $ref: 'defs.json#/definitions/ReputationApi' },
        time_awarded: { type: 'number' },
        frontend_bid_status: {
          enum: ['active', 'complete', 'in_progress'],
          type: 'string',
        },
        hireme_counter_offer: {
          $ref: 'defs.json#/definitions/HireMeCounterOfferApi',
        },
        shortlisted: { type: 'boolean' },
        score: { type: 'number' },
        distance: { type: 'number' },
        negotiated_offer: { $ref: 'defs.json#/definitions/NegotiatedOfferApi' },
        hidden: { type: 'boolean' },
        hidden_reason: {
          enum: [
            'advertising',
            'contacts',
            'fake',
            'harassment',
            'not_interesting',
          ],
          type: 'string',
        },
        time_accepted: { type: 'number' },
        paid_amount: { type: 'number' },
        hourly_rate: { type: 'number' },
        sealed: { type: 'boolean' },
        complete_status_changed_time: { type: 'number' },
        award_status_changed_time: { type: 'number' },
        is_location_tracked: { type: 'boolean' },
        rating: { $ref: 'defs.json#/definitions/BidRatingApi' },
      },
      required: [
        'amount',
        'bidder_id',
        'id',
        'period',
        'project_id',
        'project_owner_id',
        'retracted',
        'sealed',
      ],
    },
    FeeApi: {
      type: 'object',
      properties: {
        amount: { type: 'number' },
        is_taxed: { type: 'boolean' },
        currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
        rate: { type: 'number' },
        rate_with_tax: { type: 'number' },
      },
      required: ['amount', 'is_taxed'],
    },
    CurrencyApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        code: { type: 'string' },
        sign: { type: 'string' },
        name: { type: 'string' },
        exchange_rate: { type: 'number' },
        country: { type: 'string' },
        is_external: { type: 'boolean' },
        is_escrowcom_supported: { type: 'boolean' },
      },
      required: ['code', 'id', 'sign'],
    },
    ReputationApi: {
      type: 'object',
      properties: {
        entire_history: { $ref: 'defs.json#/definitions/ReputationDataApi' },
        last3months: { $ref: 'defs.json#/definitions/ReputationDataApi' },
        last12months: { $ref: 'defs.json#/definitions/ReputationDataApi' },
        user_id: { type: 'number' },
        role: { enum: ['employer', 'freelancer'], type: 'string' },
        earnings_score: { type: 'number' },
        job_history: { $ref: 'defs.json#/definitions/JobHistoryApi' },
        project_stats: {
          $ref:
            'defs.json#/definitions/{readonlyopen?:number|undefined;readonlywork_in_progress?:number|undefined;readonlycomplete?:number|undefined;readonlypending?:number|undefined;readonlydraft?:number|undefined;}',
        },
      },
      required: [
        'earnings_score',
        'entire_history',
        'last12months',
        'last3months',
      ],
    },
    ReputationDataApi: {
      type: 'object',
      properties: {
        overall: { type: 'number' },
        on_budget: { type: 'number' },
        on_time: { type: 'number' },
        positive: { type: 'number' },
        category_ratings: {
          $ref: 'defs.json#/definitions/{readonly[x:string]:number|undefined;}',
        },
        all: { type: 'number' },
        reviews: { type: 'number' },
        incomplete_reviews: { type: 'number' },
        complete: { type: 'number' },
        incomplete: { type: 'number' },
        earnings: { type: 'number' },
        completion_rate: { type: 'number' },
        rehire_rate: { type: 'number' },
      },
      required: [
        'all',
        'complete',
        'completion_rate',
        'incomplete',
        'incomplete_reviews',
        'on_budget',
        'on_time',
        'overall',
        'positive',
        'reviews',
      ],
    },
    '{readonly[x:string]:number|undefined;}': { type: 'object' },
    JobHistoryApi: {
      type: 'object',
      properties: {
        count_other: { type: 'number' },
        job_counts: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/JobCountApi' },
        },
      },
      required: ['count_other', 'job_counts'],
    },
    JobCountApi: {
      type: 'object',
      properties: {
        count: { type: 'number' },
        job: { $ref: 'defs.json#/definitions/JobApi' },
      },
      required: ['count', 'job'],
    },
    JobApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        category: { $ref: 'defs.json#/definitions/CategoryApi' },
        active_project_count: { type: 'number' },
        seo_url: { type: 'string' },
        seo_info: { $ref: 'defs.json#/definitions/JobSeoInfoApi' },
        local: { type: 'boolean' },
      },
      required: ['id'],
    },
    CategoryApi: {
      type: 'object',
      properties: { id: { type: 'number' }, name: { type: 'string' } },
      required: ['id'],
    },
    JobSeoInfoApi: {
      type: 'object',
      properties: {
        seo_text: { type: 'string' },
        seo_text_alt: { type: 'string' },
        seo_worker: { type: 'string' },
        seo_worker_alt: { type: 'string' },
        seo_worker_plural: { type: 'string' },
        seo_worker_plural_alt: { type: 'string' },
        phrase_worker: { type: 'string' },
        context_phrase_worker: { type: 'string' },
        plural_phrase_worker: { type: 'string' },
        country_person: { type: 'string' },
        country_demonym: { type: 'string' },
      },
    },
    '{readonlyopen?:number|undefined;readonlywork_in_progress?:number|undefined;readonlycomplete?:number|undefined;readonlypending?:number|undefined;readonlydraft?:number|undefined;}': {
      type: 'object',
      properties: {
        open: { type: 'number' },
        work_in_progress: { type: 'number' },
        complete: { type: 'number' },
        pending: { type: 'number' },
        draft: { type: 'number' },
      },
    },
    HireMeCounterOfferApi: {
      type: 'object',
      properties: {
        bid_id: { type: 'number' },
        description: { type: 'string' },
        status: {
          enum: ['accepted', 'expired', 'pending', 'rejected'],
          type: 'string',
        },
        amount: { type: 'number' },
        period: { type: 'number' },
        time_submitted: { type: 'number' },
        time_updated: { type: 'number' },
      },
    },
    NegotiatedOfferApi: {
      type: 'object',
      properties: {
        project_id: { type: 'number' },
        freelancer_id: { type: 'number' },
        status: {
          enum: [
            'employer_accepted',
            'employer_pending',
            'employer_rejected',
            'employer_requested',
            'freelancer_pending',
            'freelancer_rejected',
          ],
          type: 'string',
        },
        requested_milestones: { enum: ['all', 'none', 'one'], type: 'string' },
        time_updated: { type: 'number' },
      },
    },
    BidRatingApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        bid_id: { type: 'number' },
        author_id: { type: 'number' },
        rating: { type: 'number' },
        comment: { type: 'string' },
        time_created: { type: 'number' },
        time_updated: { type: 'number' },
      },
      required: ['author_id', 'bid_id', 'id', 'rating', 'time_created'],
    },
    UserApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        username: { type: 'string' },
        suspended: { type: 'boolean' },
        closed: { type: 'boolean' },
        is_active: { type: 'boolean' },
        force_verify: { type: 'boolean' },
        avatar: { type: 'string' },
        email: { type: 'string' },
        reputation: { $ref: 'defs.json#/definitions/ReputationApi' },
        jobs: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/JobApi' },
        },
        profile_description: { type: 'string' },
        hourly_rate: { type: 'number' },
        registration_date: { type: 'number' },
        limited_account: { type: 'boolean' },
        display_name: { type: 'string' },
        tagline: { type: 'string' },
        location: { $ref: 'defs.json#/definitions/LocationApi' },
        avatar_large: { type: 'string' },
        role: { enum: ['employer', 'freelancer'], type: 'string' },
        chosen_role: {
          enum: ['both', 'employer', 'freelancer'],
          type: 'string',
        },
        employer_reputation: { $ref: 'defs.json#/definitions/ReputationApi' },
        status: { $ref: 'defs.json#/definitions/UserStatusApi' },
        avatar_cdn: { type: 'string' },
        avatar_large_cdn: { type: 'string' },
        primary_currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
        account_balances: { $ref: 'defs.json#/definitions/AccountBalancesApi' },
        membership_package: {
          $ref: 'defs.json#/definitions/MembershipPackageApi',
        },
        qualifications: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/QualificationApi' },
        },
        badges: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/BadgeApi' },
        },
        primary_language: { type: 'string' },
        search_languages: { type: 'array', items: { type: 'string' } },
        cover_image: { $ref: 'defs.json#/definitions/CoverImageResultApi' },
        true_location: { $ref: 'defs.json#/definitions/LocationApi' },
        portfolio_count: { type: 'number' },
        preferred_freelancer: { type: 'boolean' },
        support_status: { $ref: 'defs.json#/definitions/SupportStatusApi' },
        first_name: { type: 'string' },
        last_name: { type: 'string' },
        mobile_tracking: {
          $ref: 'defs.json#/definitions/{readonly[x:string]:Validation;}',
        },
        corporate: { $ref: 'defs.json#/definitions/CorporateDetailsApi' },
        public_name: { type: 'string' },
        corporate_users: { type: 'array', items: { type: 'number' } },
        is_local: { type: 'boolean' },
        address: { $ref: 'defs.json#/definitions/AddressApi' },
        company: { type: 'string' },
        recommendations: { type: 'number' },
        pool_ids: {
          type: 'array',
          items: {
            enum: [
              'api_e2e',
              'arrow_private',
              'deloitte_dc',
              'facebook',
              'flnltd',
              'freelancer',
              'nokia',
            ],
            type: 'string',
          },
        },
        enterprise_ids: { type: 'array', items: { type: 'number' } },
        date_of_birth: { $ref: 'defs.json#/definitions/DateOfBirthApi' },
        escrowcom_account_linked: { type: 'boolean' },
        escrowcom_interaction_required: { type: 'boolean' },
        marketing_mobile_number: {
          $ref: 'defs.json#/definitions/MarketingMobileNumberApi',
        },
        user_sanctions: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/UserSanctionApi' },
        },
        freelancer_verified_status: {
          enum: ['accepted', 'pending', 'rejected', 'removed'],
          type: 'string',
        },
        spam_profile: { $ref: 'defs.json#/definitions/UserSpamProfileApi' },
        endorsements: { $ref: 'defs.json#/definitions/UserEndorsementsApi' },
        timezone: { $ref: 'defs.json#/definitions/TimezoneApi' },
        responsiveness: { type: 'number' },
        bid_quality_details: {
          $ref: 'defs.json#/definitions/BidQualityDetailsApi',
        },
        test_user: { type: 'boolean' },
        online_offline_status: {
          $ref: 'defs.json#/definitions/UserOnlineOfflineStatusApi',
        },
        deposit_methods: {
          $ref: 'defs.json#/definitions/DepositPageMethodsApi',
        },
        oauth_password_credentials_allowed: { type: 'boolean' },
        registration_completed: { type: 'boolean' },
        is_profile_visible: { type: 'boolean' },
        enterprise_metadata_values: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/EnterpriseMetadataValueApi' },
        },
      },
      required: ['id', 'is_profile_visible', 'username'],
    },
    LocationApi: {
      type: 'object',
      properties: {
        country: { $ref: 'defs.json#/definitions/CountryApi' },
        city: { type: 'string' },
        latitude: { type: 'number' },
        longitude: { type: 'number' },
        vicinity: { type: 'string' },
        administrative_area: { type: 'string' },
        full_address: { type: 'string' },
      },
    },
    CountryApi: {
      type: 'object',
      properties: {
        name: { type: 'string' },
        flag_url: { type: 'string' },
        code: { type: 'string' },
        highres_flag_url: { type: 'string' },
        flag_url_cdn: { type: 'string' },
        highres_flag_url_cdn: { type: 'string' },
        iso3: { type: 'string' },
        region_id: { type: 'number' },
        phone_code: { type: 'number' },
        demonym: { type: 'string' },
        person: { type: 'string' },
        seo_url: { type: 'string' },
        sanction: { type: 'boolean' },
        language_code: { type: 'string' },
        language_id: { type: 'number' },
      },
      required: ['name'],
    },
    UserStatusApi: {
      type: 'object',
      properties: {
        payment_verified: { type: 'boolean' },
        email_verified: { type: 'boolean' },
        deposit_made: { type: 'boolean' },
        profile_complete: { type: 'boolean' },
        phone_verified: { type: 'boolean' },
        identity_verified: { type: 'boolean' },
        facebook_connected: { type: 'boolean' },
        freelancer_verified_user: { type: 'boolean' },
      },
    },
    AccountBalancesApi: {
      type: 'object',
      properties: {
        balances: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/BalanceApi' },
        },
        bids_remaining: { type: 'number' },
        jobs_remaining: { type: 'number' },
        job_changes_remaining: { type: 'number' },
        service_postings_remaining: { type: 'number' },
        pending_funds: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/BalanceApi' },
        },
        equivalent_amount: { type: 'number' },
      },
    },
    BalanceApi: {
      type: 'object',
      properties: {
        amount: { type: 'number' },
        currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
      },
    },
    MembershipPackageApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        bid_limit: { type: 'number' },
        bid_refresh_rate: { type: 'number' },
        time_bid_refreshed: { type: 'number' },
        job_limit: { type: 'number' },
        job_change_limit: { type: 'number' },
        service_posting_limit: { type: 'number' },
        duration_type: {
          enum: [
            'century',
            'day',
            'decade',
            'hour',
            'millenium',
            'minute',
            'month',
            'second',
            'week',
            'year',
          ],
          type: 'string',
        },
        membership_level: { type: 'number' },
      },
    },
    QualificationApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        level: { type: 'number' },
        type: { type: 'string' },
        icon_url: { type: 'string' },
        description: { type: 'string' },
        icon_name: { type: 'string' },
        score_percentage: { type: 'number' },
        user_percentile: { type: 'number' },
      },
    },
    BadgeApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        description: { type: 'string' },
        time_awarded: { type: 'number' },
        icon_url: { type: 'string' },
      },
    },
    CoverImageResultApi: {
      type: 'object',
      properties: {
        current_image: { $ref: 'defs.json#/definitions/CoverImageApi' },
        past_images: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/CoverImageApi' },
        },
      },
    },
    CoverImageApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        url: { type: 'string' },
        description: { type: 'string' },
        width: { type: 'number' },
        height: { type: 'number' },
      },
    },
    SupportStatusApi: {
      type: 'object',
      properties: {
        type: { $ref: 'defs.json#/definitions/UserSupportTypeApi' },
        short_name: { type: 'string' },
      },
      required: ['type'],
    },
    UserSupportTypeApi: {
      enum: [
        'arrow_concierge',
        'assisted',
        'general',
        'local',
        'membership_curation',
        'payment_satisfaction',
        'project_management',
        'success_manager',
        'technical',
      ],
      type: 'string',
    },
    '{readonly[x:string]:Validation;}': { type: 'object' },
    CorporateDetailsApi: {
      type: 'object',
      properties: {
        status: { enum: ['active', 'expired', 'pending'], type: 'string' },
        founder_id: { type: 'number' },
      },
    },
    AddressApi: {
      type: 'object',
      properties: {
        address1: { type: 'string' },
        address2: { type: 'string' },
        city: { type: 'string' },
        state_code: { type: 'string' },
        zip: { type: 'string' },
        country: { type: 'string' },
      },
    },
    DateOfBirthApi: {
      type: 'object',
      properties: {
        day: { type: 'number' },
        month: { type: 'number' },
        year: { type: 'number' },
      },
      required: ['day', 'month', 'year'],
    },
    MarketingMobileNumberApi: {
      type: 'object',
      properties: {
        phone_number: { type: 'string' },
        country_code: { type: 'string' },
        status: { enum: ['invalid', 'valid'], type: 'string' },
      },
      required: ['country_code', 'phone_number'],
    },
    UserSanctionApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        start_date: { type: 'number' },
        end_date: { type: 'number' },
        reason: { type: 'string', enum: ['bid_spam'] },
        penalty: { type: 'string', enum: ['bid_restriction'] },
      },
      required: ['end_date', 'id', 'penalty', 'reason', 'start_date'],
    },
    UserSpamProfileApi: {
      type: 'object',
      properties: {
        account_balance: { type: 'number' },
        payment_verification: { type: 'boolean' },
        email_verification: { type: 'boolean' },
        ratecount: { type: 'number' },
        regdate: { type: 'number' },
        closed: { type: 'boolean' },
      },
      required: [
        'account_balance',
        'closed',
        'email_verification',
        'payment_verification',
        'ratecount',
        'regdate',
      ],
    },
    UserEndorsementsApi: {
      type: 'object',
      properties: { review_count: { type: 'number' } },
    },
    TimezoneApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        country: { type: 'string' },
        timezone: { type: 'string' },
        offset: { type: 'number' },
      },
    },
    BidQualityDetailsApi: {
      type: 'object',
      properties: { user_id: { type: 'number' }, score: { type: 'number' } },
      required: ['score', 'user_id'],
    },
    UserOnlineOfflineStatusApi: {
      type: 'object',
      properties: {
        status: { $ref: 'defs.json#/definitions/OnlineOfflineStatusApi' },
        last_updated_timestamp: { type: 'number' },
      },
      required: ['status'],
    },
    OnlineOfflineStatusApi: { enum: ['offline', 'online'], type: 'string' },
    DepositPageMethodsApi: {
      type: 'object',
      properties: {
        deposit_methods: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/DepositPageMethodApi' },
        },
        is_cc_eligible: { type: 'boolean' },
      },
      required: ['deposit_methods', 'is_cc_eligible'],
    },
    DepositPageMethodApi: {
      type: 'object',
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        default_currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
        deposit_fee_configs: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/DepositFeeConfigApi' },
        },
        native_charge: { type: 'boolean' },
        rendering_priority: { type: 'number' },
        instant_payment: { type: 'boolean' },
      },
      required: [
        'default_currency',
        'deposit_fee_configs',
        'id',
        'instant_payment',
        'name',
        'native_charge',
        'rendering_priority',
      ],
    },
    DepositFeeConfigApi: {
      type: 'object',
      properties: {
        currency_id: { type: 'number' },
        min_amount: { type: 'number' },
        max_amount: { type: 'number' },
        deposit_method: {
          enum: [
            'alipay',
            'applepay',
            'bancontact',
            'boleto',
            'dev_credits',
            'dotpay',
            'fln_billing',
            'giropay',
            'googlepay',
            'ideal',
            'interac',
            'loc',
            'paypal',
            'paypal_reference',
            'paytm',
            'paytm_subscription',
            'skrill',
            'sofort',
            'union_pay',
            'web_money',
            'wechatpay',
            'wire',
          ],
          type: 'string',
        },
        fee_fixed_amount: { type: 'number' },
        fee_rate: { type: 'number' },
        country_code: { type: 'string' },
      },
      required: ['currency_id', 'max_amount', 'min_amount'],
    },
    EnterpriseMetadataValueApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        enterprise_metadata_field_id: { type: 'number' },
        resource_id: { type: 'number' },
        value: { $ref: 'defs.json#/definitions/MetadataValueApi' },
        time_created: { type: 'number' },
      },
      required: [
        'enterprise_metadata_field_id',
        'id',
        'resource_id',
        'time_created',
        'value',
      ],
    },
    MetadataValueApi: {
      type: 'object',
      properties: {
        boolean_value: {
          $ref: 'defs.json#/definitions/MetadataValueBooleanApi',
        },
        float_value: { $ref: 'defs.json#/definitions/MetadataValueFloatApi' },
        integer_value: {
          $ref: 'defs.json#/definitions/MetadataValueIntegerApi',
        },
        timestamp_value: {
          $ref: 'defs.json#/definitions/MetadataValueTimestampApi',
        },
        location_value: {
          $ref: 'defs.json#/definitions/MetadataValueLocationApi',
        },
        text_value: {
          $ref: 'defs.json#/definitions/MetadataValueTextSmallApi',
        },
      },
    },
    MetadataValueBooleanApi: {
      type: 'object',
      properties: { value: { type: 'boolean' } },
      required: ['value'],
    },
    MetadataValueFloatApi: {
      type: 'object',
      properties: { value: { type: 'number' } },
      required: ['value'],
    },
    MetadataValueIntegerApi: {
      type: 'object',
      properties: { value: { type: 'number' } },
      required: ['value'],
    },
    MetadataValueTimestampApi: {
      type: 'object',
      properties: { value: { type: 'number' } },
      required: ['value'],
    },
    MetadataValueLocationApi: {
      type: 'object',
      properties: {
        latitude: { type: 'number' },
        longitude: { type: 'number' },
      },
      required: ['latitude', 'longitude'],
    },
    MetadataValueTextSmallApi: {
      type: 'object',
      properties: { value: { type: 'string' } },
      required: ['value'],
    },
    ProjectApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        owner_id: { type: 'number' },
        title: { type: 'string' },
        status: { $ref: 'defs.json#/definitions/ProjectStatusApi' },
        sub_status: {
          enum: [
            'cancel_admin',
            'cancel_buyer',
            'cancel_seller',
            'closed_awarded',
            'closed_expired',
            'frozen_awarded',
            'frozen_timeout',
          ],
          type: 'string',
        },
        seo_url: { type: 'string' },
        currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
        description: { type: 'string' },
        jobs: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/JobApi' },
        },
        submitdate: { type: 'number' },
        preview_description: { type: 'string' },
        deleted: { type: 'boolean' },
        nonpublic: { type: 'boolean' },
        hidebids: { type: 'boolean' },
        type: { enum: ['fixed', 'hourly'], type: 'string' },
        bidperiod: { type: 'number' },
        budget: { $ref: 'defs.json#/definitions/BudgetApi' },
        hourly_project_info: {
          $ref: 'defs.json#/definitions/HourlyProjectInfoApi',
        },
        featured: { type: 'boolean' },
        urgent: { type: 'boolean' },
        assisted: { type: 'boolean' },
        active_prepaid_milestone: {
          $ref: 'defs.json#/definitions/PrepaidMilestoneApi',
        },
        bid_stats: { $ref: 'defs.json#/definitions/ProjectBidStatsApi' },
        time_submitted: { type: 'number' },
        time_updated: { type: 'number' },
        upgrades: { $ref: 'defs.json#/definitions/ProjectUpgradesApi' },
        qualifications: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/QualificationApi' },
        },
        language: { type: 'string' },
        attachments: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectAttachmentApi' },
        },
        hireme: { type: 'boolean' },
        hireme_initial_bid: { $ref: 'defs.json#/definitions/BidApi' },
        invited_freelancers: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/UserApi' },
        },
        recommended_freelancers: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/UserApi' },
        },
        frontend_project_status: {
          enum: ['complete', 'draft', 'open', 'pending', 'work_in_progress'],
          type: 'string',
        },
        nda_signatures: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/NDASignatureApi' },
        },
        location: { $ref: 'defs.json#/definitions/LocationApi' },
        true_location: { $ref: 'defs.json#/definitions/LocationApi' },
        local: { type: 'boolean' },
        negotiated: { type: 'boolean' },
        negotiated_bid: { $ref: 'defs.json#/definitions/BidApi' },
        time_free_bids_expire: { type: 'number' },
        can_post_review: {
          $ref: 'defs.json#/definitions/ReviewAvailabilityApi',
        },
        files: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectFileApi' },
        },
        user_distance: { type: 'number' },
        from_user_location: { type: 'boolean' },
        project_collaborations: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectCollaborationApi' },
        },
        support_sessions: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/SupportSessionApi' },
        },
        track_ids: { type: 'array', items: { type: 'number' } },
        drive_files: { type: 'boolean' },
        nda_details: { $ref: 'defs.json#/definitions/NDADetailsApi' },
        pool_ids: {
          type: 'array',
          items: {
            enum: [
              'api_e2e',
              'arrow_private',
              'deloitte_dc',
              'facebook',
              'flnltd',
              'freelancer',
              'nokia',
            ],
            type: 'string',
          },
        },
        enterprise_ids: { type: 'array', items: { type: 'number' } },
        timeframe: { $ref: 'defs.json#/definitions/ProjectTimeframeApi' },
        deloitte_details: {
          $ref: 'defs.json#/definitions/DeloitteProjectDetailsApi',
        },
        is_escrow_project: { type: 'boolean' },
        is_seller_kyc_required: { type: 'boolean' },
        is_buyer_kyc_required: { type: 'boolean' },
        local_details: {
          $ref: 'defs.json#/definitions/ProjectLocalDetailsApi',
        },
        equipment: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/EquipmentApi' },
        },
        nda_signatures_new: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/NDASignatureApi' },
        },
        billing_code: { type: 'string' },
        enterprise_metadata_values: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/EnterpriseMetadataValueApi' },
        },
      },
      required: [
        'deleted',
        'hidebids',
        'id',
        'is_buyer_kyc_required',
        'is_escrow_project',
        'is_seller_kyc_required',
        'nonpublic',
        'owner_id',
        'status',
        'title',
      ],
    },
    ProjectStatusApi: {
      enum: ['active', 'closed', 'draft', 'frozen', 'pending', 'rejected'],
      type: 'string',
    },
    BudgetApi: {
      type: 'object',
      properties: {
        minimum: { type: 'number' },
        maximum: { type: 'number' },
        name: { type: 'string' },
        project_type: { enum: ['fixed', 'hourly'], type: 'string' },
        currency_id: { type: 'number' },
      },
      required: ['currency_id', 'minimum'],
    },
    HourlyProjectInfoApi: {
      type: 'object',
      properties: {
        commitment: { $ref: 'defs.json#/definitions/CommitmentApi' },
        duration_enum: {
          enum: [
            'less_than_one_week',
            'one_to_four_weeks',
            'one_to_three_months',
            'ongoing',
            'three_to_six_months',
            'unknown',
            'unspecified',
          ],
          type: 'string',
        },
      },
      required: ['commitment'],
    },
    CommitmentApi: {
      type: 'object',
      properties: {
        hours: { type: 'number' },
        interval: { $ref: 'defs.json#/definitions/TimeUnitApi' },
      },
      required: ['hours', 'interval'],
    },
    TimeUnitApi: {
      enum: [
        'century',
        'day',
        'decade',
        'hour',
        'millenium',
        'minute',
        'month',
        'second',
        'week',
        'year',
      ],
      type: 'string',
    },
    PrepaidMilestoneApi: {
      type: 'object',
      properties: {
        amount: { type: 'number' },
        status: {
          enum: ['cancelled', 'cleared', 'error', 'locked', 'to_be_prepared'],
          type: 'string',
        },
        to_user_id: { type: 'number' },
      },
      required: ['amount'],
    },
    ProjectBidStatsApi: {
      type: 'object',
      properties: {
        bid_count: { type: 'number' },
        bid_avg: { type: 'number' },
      },
    },
    ProjectUpgradesApi: {
      type: 'object',
      properties: {
        featured: { type: 'boolean' },
        sealed: { type: 'boolean' },
        nonpublic: { type: 'boolean' },
        fulltime: { type: 'boolean' },
        urgent: { type: 'boolean' },
        qualified: { type: 'boolean' },
        NDA: { type: 'boolean' },
        assisted: { type: 'boolean' },
        active_prepaid_milestone: {
          $ref: 'defs.json#/definitions/PrepaidMilestoneApi',
        },
        ip_contract: { type: 'boolean' },
        success_bundle: { type: 'boolean' },
        non_compete: { type: 'boolean' },
        project_management: { type: 'boolean' },
        pf_only: { type: 'boolean' },
        recruiter: { type: 'boolean' },
        listed: { type: 'boolean' },
        extend: { type: 'boolean' },
        unpaid_recruiter: { type: 'boolean' },
      },
    },
    ProjectAttachmentApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        filename: { type: 'string' },
        time_submitted: { type: 'number' },
        url: { type: 'string' },
        access_hash: { type: 'string' },
        content_type: { type: 'string' },
      },
      required: ['id'],
    },
    NDASignatureApi: {
      type: 'object',
      properties: {
        project_id: { type: 'number' },
        user_id: { type: 'number' },
        time_signed: { type: 'number' },
      },
    },
    ReviewAvailabilityApi: {
      type: 'object',
      properties: {
        freelancer: { type: 'boolean' },
        employer: { type: 'boolean' },
      },
    },
    ProjectFileApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        from_user_id: { type: 'number' },
        to_user_id: { type: 'number' },
        project_id: { type: 'number' },
        file_name: { type: 'string' },
        file_size: { type: 'number' },
        time_submitted: { type: 'number' },
        url: { type: 'string' },
        content_type: { type: 'string' },
      },
    },
    ProjectCollaborationApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        user_id: { type: 'number' },
        context: { $ref: 'defs.json#/definitions/ContextApi' },
        context_owner_id: { type: 'number' },
        status: {
          $ref: 'defs.json#/definitions/ProjectCollaborationStatusApi',
        },
        invite_token: { type: 'string' },
        permissions: {
          type: 'array',
          items: {
            enum: [
              'bid_award',
              'chat',
              'collaborator_add',
              'dispute_create',
              'file_upload',
              'milestone_create',
              'milestone_release',
              'milestone_request',
              'milestone_view',
              'project_details_edit',
              'task_list_edit',
              'tracked_hours_approve',
              'unknown',
            ],
            type: 'string',
          },
        },
        time_created: { type: 'number' },
        time_updated: { type: 'number' },
        contest_collaboration_permissions: {
          type: 'array',
          items: {
            enum: ['entry_award', 'entry_rate', 'entry_reject', 'unknown'],
            type: 'string',
          },
        },
        obscured_email_address: { type: 'string' },
      },
      required: ['context_owner_id', 'id', 'status'],
    },
    ContextApi: {
      type: 'object',
      properties: {
        type: { $ref: 'defs.json#/definitions/ContextTypeApi' },
        id: { type: 'number' },
      },
      required: ['id', 'type'],
    },
    ContextTypeApi: { enum: ['contest', 'none', 'project'], type: 'string' },
    ProjectCollaborationStatusApi: {
      enum: [
        'accept_pending',
        'active',
        'inactive',
        'signup_pending',
        'unknown',
      ],
      type: 'string',
    },
    SupportSessionApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        user_id: { type: 'number' },
        support_type: { type: 'string' },
        source_id: { type: 'number' },
        create_time: { type: 'number' },
        agent_session: { $ref: 'defs.json#/definitions/AgentSessionApi' },
      },
      required: [
        'agent_session',
        'create_time',
        'id',
        'source_id',
        'support_type',
        'user_id',
      ],
    },
    AgentSessionApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        support_type: { type: 'string' },
        support_agent: { $ref: 'defs.json#/definitions/SupportAgentApi' },
        support_session_id: { type: 'number' },
        create_time: { type: 'number' },
        resolved_time: { type: 'number' },
        resolved_reason: { type: 'string' },
        is_latest: { type: 'boolean' },
      },
      required: [
        'create_time',
        'id',
        'is_latest',
        'resolved_reason',
        'resolved_time',
        'support_agent',
        'support_session_id',
        'support_type',
      ],
    },
    SupportAgentApi: {
      type: 'object',
      properties: { id: { type: 'number' }, user_id: { type: 'number' } },
      required: ['id', 'user_id'],
    },
    NDADetailsApi: {
      type: 'object',
      properties: {
        hidden_description: { type: 'string' },
        signatures: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/NDASignatureApi' },
        },
        hidden_files: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectFileApi' },
        },
        hidden_attachments: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectAttachmentApi' },
        },
      },
    },
    ProjectTimeframeApi: {
      type: 'object',
      properties: {
        start_date: { type: 'number' },
        end_date: { type: 'number' },
      },
    },
    DeloitteProjectDetailsApi: {
      type: 'object',
      properties: {
        billing_code: { type: 'string' },
        industry_offering: {
          $ref: 'defs.json#/definitions/DeloitteIndustryOfferingApi',
        },
        clearance: { type: 'string' },
        itar: { type: 'string' },
      },
      required: ['billing_code', 'industry_offering'],
    },
    DeloitteIndustryOfferingApi: {
      type: 'object',
      properties: {
        project_type: { $ref: 'defs.json#/definitions/DeloitteProjectTypeApi' },
        practice: { $ref: 'defs.json#/definitions/DeloittePracticeApi' },
        industry: { $ref: 'defs.json#/definitions/DeloitteIndustryApi' },
        offering: { $ref: 'defs.json#/definitions/DeloitteOfferingApi' },
      },
      required: ['industry', 'offering', 'practice', 'project_type'],
    },
    DeloitteProjectTypeApi: {
      enum: [
        'client_billable',
        'firm_initiative',
        'internal_services',
        'other_investment',
        'prd',
        'skills_based_volunteering',
      ],
      type: 'string',
    },
    DeloittePracticeApi: {
      enum: [
        'commercial_core',
        'commercial_usdc_incenter',
        'commercial_usdc_onsite',
        'gps_core',
        'gps_operational_excellence',
        'gps_usdc_incenter',
        'gps_usdc_onsite',
        'usi_offshore',
        'usi_onsite',
      ],
      type: 'string',
    },
    DeloitteIndustryApi: {
      enum: [
        'automotive',
        'banking_and_capital_markets',
        'civil_government',
        'consumer_products',
        'cross_sector_c',
        'cross_sector_ci',
        'cross_sector_eri',
        'cross_sector_fs',
        'cross_sector_gps',
        'cross_sector_lshc',
        'cross_sector_tmt',
        'defense_security_and_justice',
        'federal_health',
        'health_care',
        'industrial_products_and_construction',
        'insurance',
        'investment_management',
        'media_and_entertainment',
        'oil_gas_and_chemicals',
        'power_and_utilities',
        'real_estate',
        'retail_wholesale_and_distribution',
        'state_local_and_higher_education',
        'technology',
        'telecom_media_and_entertainment',
        'transportation_hospitality_and_services',
      ],
      type: 'string',
    },
    DeloitteOfferingApi: {
      enum: [
        'cbo_cloud_engineering',
        'cbo_core_industry_solutions',
        'cbo_cross_consulting_group',
        'cbo_health_technology',
        'cbo_operations_transformation',
        'cbo_other',
        'cbo_systems_engineering',
        'cnm_advertising_marketing_and_commerce',
        'cnm_asset_group',
        'cnm_cross_consulting_group',
        'cnm_customer_strategy_and_applied_design',
        'cnm_digital_customer',
        'cnm_human_services_transformation',
        'cnm_other',
        'eo_asset_group',
        'eo_cross_consulting_group',
        'eo_erp_saas',
        'eo_finance_and_enterprise_performance',
        'eo_oracle',
        'eo_other',
        'eo_sap',
        'eo_supply_chain_and_network_operations',
        'eo_technology_services_optimization',
        'hc_asset_group',
        'hc_cross_consulting_group',
        'hc_hc_as_a_service',
        'hc_hr_transformation',
        'hc_organization_transformation',
        'hc_other',
        'hc_workforce_transformation',
        'is_gps_business_services',
        'is_gps_business_systems',
        'is_gps_compliance',
        'is_gps_contracts',
        'is_gps_finance',
        'is_gps_ops_management',
        'is_gps_security',
        'is_gps_talent',
        'mna_ccg',
        'mna_integration_and_divesture',
        'mna_mergers_and_acquisitions',
        'mna_other',
        'nc_adjustments_or_other',
        'nc_alliances',
        'nc_c_suite',
        'nc_client_and_industry',
        'nc_client_excellence',
        'nc_cloud',
        'nc_corporate_development',
        'nc_delivery_excellence',
        'nc_dtoc',
        'nc_international',
        'nc_n_o_global_consulting_office',
        'nc_national_consulting',
        'nc_offering_portfolio',
        'nc_operation_and_finance',
        'nc_other_usi',
        'nc_partner_matters',
        'nc_sales_and_pursuit_excellence',
        'nc_strategy',
        'nc_talent',
        'nc_tech_and_innovation',
        'p_organic',
        'p_snet',
        'sna_analytics_and_cognitive',
        'sna_asset_group',
        'sna_cross_consulting_group',
        'sna_hybrid_solutions_and_incubation',
        'sna_other',
        'sna_strategy',
      ],
      type: 'string',
    },
    ProjectLocalDetailsApi: {
      type: 'object',
      properties: {
        project_id: { type: 'number' },
        date: { $ref: 'defs.json#/definitions/ProjectLocalDetailsDateApi' },
        end_location: { $ref: 'defs.json#/definitions/LocationApi' },
      },
      required: ['project_id'],
    },
    ProjectLocalDetailsDateApi: {
      type: 'object',
      properties: {
        year: { type: 'number' },
        month: { type: 'number' },
        day: { type: 'number' },
      },
      required: ['day', 'month', 'year'],
    },
    EquipmentApi: {
      type: 'object',
      properties: { id: { type: 'number' }, name: { type: 'string' } },
      required: ['id'],
    },
    ContactApi: {
      type: 'object',
      properties: {
        user: { $ref: 'defs.json#/definitions/UserApi' },
        relationships: {
          $ref:
            'defs.json#/definitions/{readonlyfriend?:RelationshipApi|undefined;readonlyconnection?:RelationshipApi|undefined;readonlycontext?:RelationshipApi|undefined;readonlycompany?:RelationshipApi|undefined;readonlypreferred_freelancer?:RelationshipApi|undefined;}',
        },
        contexts: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ContextApi' },
        },
        muted: { type: 'boolean' },
        role: { enum: ['employer', 'freelancer'], type: 'string' },
        settings: { $ref: 'defs.json#/definitions/ContactSettingsApi' },
      },
      required: ['user'],
    },
    '{readonlyfriend?:RelationshipApi|undefined;readonlyconnection?:RelationshipApi|undefined;readonlycontext?:RelationshipApi|undefined;readonlycompany?:RelationshipApi|undefined;readonlypreferred_freelancer?:RelationshipApi|undefined;}': {
      type: 'object',
      properties: {
        friend: { $ref: 'defs.json#/definitions/RelationshipApi' },
        connection: { $ref: 'defs.json#/definitions/RelationshipApi' },
        context: { $ref: 'defs.json#/definitions/RelationshipApi' },
        company: { $ref: 'defs.json#/definitions/RelationshipApi' },
        preferred_freelancer: {
          $ref: 'defs.json#/definitions/RelationshipApi',
        },
      },
    },
    RelationshipApi: {
      type: 'object',
      properties: {
        type: { $ref: 'defs.json#/definitions/ContactTypeApi' },
        weight: { type: 'number' },
      },
      required: ['type'],
    },
    ContactTypeApi: {
      enum: [
        'company',
        'connection',
        'context',
        'friend',
        'preferred_freelancer',
      ],
      type: 'string',
    },
    ContactSettingsApi: {
      type: 'object',
      properties: {
        state: {
          enum: ['active', 'blocked', 'muted', 'removed'],
          type: 'string',
        },
      },
    },
    ContextDetailsApi: {
      type: 'object',
      properties: {
        projects: {
          type: 'object',
          additionalProperties: false,
          patternProperties: {
            '^[0-9]+$': { $ref: 'defs.json#/definitions/ProjectApi' },
          },
        },
      },
    },
    ContestApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        owner_id: { type: 'number' },
        title: { type: 'string' },
        seo_url: { type: 'string' },
        currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
        time_submitted: { type: 'number' },
        prize: { type: 'number' },
        jobs: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/JobApi' },
        },
        description: { type: 'string' },
        status: {
          enum: [
            'active',
            'active_not_expired',
            'closed',
            'inactive',
            'pending',
          ],
          type: 'string',
        },
        locked: { type: 'boolean' },
        duration: { type: 'number' },
        type: {
          enum: ['freemium', 'guaranteed', 'prepaid', 'regular'],
          type: 'string',
        },
        time_posted: { type: 'number' },
        time_ended: { type: 'number' },
        time_modified: { type: 'number' },
        deleted: { type: 'boolean' },
        time_locked: { type: 'number' },
        language: { type: 'string' },
        upgrades: { $ref: 'defs.json#/definitions/ContestUpgradesApi' },
        files: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ContestFileApi' },
        },
        extended: { type: 'boolean' },
        entry_count: { type: 'number' },
        time_signed: { type: 'number' },
        interested_freelancer_count: { type: 'number' },
        accepted_file_formats: { type: 'array', items: { type: 'string' } },
        is_prize_autodistributed: { type: 'boolean' },
        seo_url_new: { type: 'string' },
        pool_ids: {
          type: 'array',
          items: {
            enum: [
              'api_e2e',
              'arrow_private',
              'deloitte_dc',
              'facebook',
              'flnltd',
              'freelancer',
              'nokia',
            ],
            type: 'string',
          },
        },
        enterprise_id: { type: 'number' },
      },
      required: ['id'],
    },
    ContestUpgradesApi: {
      type: 'object',
      properties: {
        featured: { type: 'boolean' },
        sealed: { type: 'boolean' },
        topcontest: { type: 'boolean' },
        highlighted: { type: 'boolean' },
        urgent: { type: 'boolean' },
        nonpublic: { type: 'boolean' },
        nda: { type: 'boolean' },
      },
    },
    ContestFileApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        url: { type: 'string' },
        deleted: { type: 'boolean' },
        contest_id: { type: 'number' },
      },
    },
    EntryApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        contest_id: { type: 'number' },
        contest_owner_id: { type: 'number' },
        owner_id: { type: 'number' },
        status: { $ref: 'defs.json#/definitions/EntryStatusApi' },
        number: { type: 'number' },
        title: { type: 'string' },
        description: { type: 'string' },
        upgrades: { $ref: 'defs.json#/definitions/EntryUpgradesApi' },
        files: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/EntryFileApi' },
        },
        rating: { type: 'number' },
        time_entered: { type: 'number' },
        time_eliminated: { type: 'number' },
        time_won: { type: 'number' },
        deleted: { type: 'boolean' },
        like_count: { type: 'number' },
        sell_price: { type: 'number' },
        is_liked: { type: 'boolean' },
        handover_id: { type: 'number' },
        seo_url: { type: 'string' },
        stock_items: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/EntryStockItemApi' },
        },
        file_name: { type: 'string' },
        file_path: { type: 'string' },
        has_feedback: { type: 'boolean' },
        freelancer_rating: { type: 'number' },
      },
      required: [
        'contest_id',
        'contest_owner_id',
        'id',
        'number',
        'owner_id',
        'seo_url',
        'status',
      ],
    },
    EntryStatusApi: {
      enum: [
        'active',
        'bought',
        'chosen',
        'draft',
        'eliminated',
        'pending',
        'withdrawn',
        'withdrawn_eliminated',
        'won',
        'won_bronze',
        'won_closed',
        'won_gold',
        'won_runner_up',
        'won_silver',
      ],
      type: 'string',
    },
    EntryUpgradesApi: {
      type: 'object',
      properties: {
        sealed: { type: 'boolean' },
        highlight: { type: 'boolean' },
      },
    },
    EntryFileApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        file_url: { type: 'string' },
        thumbnail_url: { type: 'string' },
        thumbnail_420_url: { type: 'string' },
        thumbnail_900_url: { type: 'string' },
        thumbnail_80_url: { type: 'string' },
        thumbnail_80_fix_url: { type: 'string' },
        thumbnail_digest_url: { type: 'string' },
        thumbnail_preview: { type: 'string' },
      },
      required: ['id'],
    },
    EntryStockItemApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        link: { type: 'string' },
        is_free: { type: 'boolean' },
      },
      required: ['id', 'is_free', 'link', 'name'],
    },
    ThreadApi: {
      type: 'object',
      properties: {
        message: { $ref: 'defs.json#/definitions/MessageApi' },
        replies: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/MessageApi' },
        },
      },
      required: ['message'],
    },
    MessageApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        board: { $ref: 'defs.json#/definitions/MessageBoardApi' },
        contest_id: { type: 'number' },
        comment: { type: 'string' },
        entry_id: { type: 'number' },
        parent_id: { type: 'number' },
        is_private: { type: 'boolean' },
        from_user_id: { type: 'number' },
        to_user_id: { type: 'number' },
        annotation_id: { type: 'number' },
        x_coordinate: { type: 'number' },
        y_coordinate: { type: 'number' },
        file_id: { type: 'number' },
        user_url: { type: 'string' },
        timestamp: { type: 'number' },
      },
      required: ['board', 'comment', 'contest_id'],
    },
    MessageBoardApi: {
      enum: ['cvp', 'entries_by_freelancer', 'entry', 'handover'],
      type: 'string',
    },
    MilestoneRequestApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        bidder_id: { type: 'number' },
        bid_id: { type: 'number' },
        time_requested: { type: 'number' },
        amount: { type: 'number' },
        project_owner_id: { type: 'number' },
        project_id: { type: 'number' },
        description: { type: 'string' },
        currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
        status: {
          enum: ['created', 'deleted', 'pending', 'rejected', 'unknown'],
          type: 'string',
        },
        requester_id: { type: 'number' },
      },
    },
    MilestoneApi: {
      type: 'object',
      properties: {
        transaction_id: { type: 'number' },
        project_owner_id: { type: 'number' },
        bidder_id: { type: 'number' },
        amount: { type: 'number' },
        reason: {
          enum: [
            'full_payment',
            'other',
            'partial_payment',
            'task_description',
          ],
          type: 'string',
        },
        other_reason: { type: 'string' },
        project_id: { type: 'number' },
        bid_id: { type: 'number' },
        currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
        is_from_prepaid: { type: 'boolean' },
        status: {
          enum: [
            'canceled',
            'cleared',
            'disputed',
            'frozen',
            'pending',
            'pending_clearance',
            'pending_recipient_kyc',
            'requested_release',
            'unknown',
          ],
          type: 'string',
        },
        dispute_id: { type: 'number' },
        time_created: { type: 'number' },
        cancellation_requested: { type: 'boolean' },
        cancellation_reason: {
          enum: [
            'accidentally_created',
            'freelancer_did_not_complete_task',
            'freelancer_did_not_meet_deadline',
            'no_longer_needed',
            'other',
          ],
          type: 'string',
        },
        reason_text: { type: 'string' },
        project_enterprise_ids: { type: 'array', items: { type: 'number' } },
        time_released: { type: 'number' },
      },
    },
    ThreadApi_1: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        thread: { $ref: 'defs.json#/definitions/BaseThreadApi' },
        is_muted: { type: 'boolean' },
        is_read: { type: 'boolean' },
        is_read_only: { type: 'boolean' },
        folder: {
          enum: ['archived', 'freelancer', 'inbox', 'none', 'sent'],
          type: 'string',
        },
        time_read: { type: 'number' },
        time_updated: { type: 'number' },
        messages: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/MessageApi_1' },
        },
        thread_events: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ThreadEventApi' },
        },
        message_count: { type: 'number' },
        message_unread_count: { type: 'number' },
        highlights: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/HighlightApi' },
        },
        attachments: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/AttachmentApi' },
        },
        is_blocked: { type: 'boolean' },
      },
      required: ['id', 'thread'],
    },
    BaseThreadApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        thread_type: { $ref: 'defs.json#/definitions/ThreadTypeApi' },
        time_created: { type: 'number' },
        members: { type: 'array', items: { type: 'number' } },
        inactive_members: { type: 'array', items: { type: 'number' } },
        owner: { type: 'number' },
        context: { $ref: 'defs.json#/definitions/ContextApi_1' },
        read_privacy: {
          enum: ['all', 'members', 'mine', 'none', 'owner', 'owner_autochat'],
          type: 'string',
        },
        owner_read_privacy: {
          enum: ['all', 'members', 'mine', 'none', 'owner', 'owner_autochat'],
          type: 'string',
        },
        write_privacy: {
          enum: ['all', 'members', 'mine', 'none', 'owner', 'owner_autochat'],
          type: 'string',
        },
        message: { $ref: 'defs.json#/definitions/MessageApi_1' },
        thread_read_annotations: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ThreadReadAnnotationApi' },
        },
        warnings: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/MessageWarningApi' },
        },
        user_read_times: {
          type: 'object',
          additionalProperties: false,
          patternProperties: { '^[0-9]+$': { type: 'number' } },
        },
      },
      required: ['members', 'thread_type'],
    },
    ThreadTypeApi: {
      enum: [
        'admin_preferred_chat',
        'comment_feed',
        'group',
        'pcb',
        'primary',
        'private_chat',
        'support_chat',
        'team',
        'team_official',
      ],
      type: 'string',
    },
    ContextApi_1: {
      type: 'object',
      properties: {
        type: { $ref: 'defs.json#/definitions/ContextTypeApi_1' },
        id: { type: 'number' },
      },
      required: ['type'],
    },
    ContextTypeApi_1: {
      enum: [
        'contest',
        'none',
        'post',
        'prehire',
        'project',
        'support_chat',
        'support_session',
        'team',
      ],
      type: 'string',
    },
    MessageApi_1: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        from_user: { type: 'number' },
        thread_id: { type: 'number' },
        parent_id: { type: 'number' },
        time_created: { type: 'number' },
        message: { type: 'string' },
        attachments: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/AttachmentApi' },
        },
        remove_reason: { $ref: 'defs.json#/definitions/RemovalReasonApi' },
        message_source: { $ref: 'defs.json#/definitions/SourceTypeApi' },
        client_message_id: { type: 'string' },
        rich_message: { $ref: 'defs.json#/definitions/RichMessageApi' },
        highlight: { $ref: 'defs.json#/definitions/HighlightApi' },
        attachments_new: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/AttachmentApi' },
        },
        quoted_message_id: { type: 'number' },
      },
      required: [
        'from_user',
        'id',
        'message',
        'message_source',
        'parent_id',
        'remove_reason',
        'thread_id',
        'time_created',
      ],
    },
    AttachmentApi: {
      type: 'object',
      properties: {
        key: { type: 'string' },
        filename: { type: 'string' },
        message_id: { type: 'number' },
        time_created: { type: 'number' },
        from_user: { type: 'number' },
        id: { type: 'number' },
        thread_id: { type: 'number' },
      },
      required: ['filename'],
    },
    RemovalReasonApi: {
      enum: [
        'advertising',
        'contacts',
        'fake',
        'harassment',
        'milestone_release_abuse',
        'nonfeatured',
        'offsiting',
        'other',
        'privacy_delete',
      ],
      type: 'string',
    },
    SourceTypeApi: {
      enum: [
        'admin',
        'android',
        'autochat',
        'bid',
        'blast',
        'bot',
        'chat_box',
        'default_msg',
        'desktop_application',
        'hireme',
        'imported',
        'inbox',
        'ios',
        'membership',
        'mobile_web',
        'smtp',
        'user_side_action',
      ],
      type: 'string',
    },
    RichMessageApi: {
      type: 'object',
      properties: {
        visibility: { $ref: 'defs.json#/definitions/VisibilityApi' },
        content: { type: 'string' },
        reference: { $ref: 'defs.json#/definitions/ReferenceApi' },
        category: { type: 'string' },
        latest_submissions: { type: 'string' },
      },
      required: ['content', 'reference', 'visibility'],
    },
    VisibilityApi: {
      type: 'object',
      properties: {
        state: { $ref: 'defs.json#/definitions/VisibilityStateApi' },
        members: { type: 'array', items: { type: 'number' } },
        active: { type: 'boolean' },
      },
      required: ['members', 'state'],
    },
    VisibilityStateApi: {
      enum: ['all', 'excludes', 'includes', 'none'],
      type: 'string',
    },
    ReferenceApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        type: { $ref: 'defs.json#/definitions/ReferenceTypeApi' },
      },
      required: ['id', 'type'],
    },
    ReferenceTypeApi: {
      enum: [
        'bid',
        'contest',
        'milestone',
        'prehire',
        'project',
        'selected_seller',
        'support_session',
        'task',
      ],
      type: 'string',
    },
    HighlightApi: {
      type: 'object',
      properties: {
        field: { $ref: 'defs.json#/definitions/HighlightedFieldApi' },
        highlighted_text: { type: 'array', items: { type: 'string' } },
        field_id: { type: 'number' },
      },
      required: ['field', 'field_id', 'highlighted_text'],
    },
    HighlightedFieldApi: { enum: ['message', 'username'], type: 'string' },
    ThreadReadAnnotationApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        thread_id: { type: 'number' },
        annotator_user_id: { type: 'number' },
        time_read: { type: 'number' },
      },
      required: ['annotator_user_id', 'thread_id', 'time_read'],
    },
    MessageWarningApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        message_id: { type: 'number' },
        thread_id: { type: 'number' },
        warning_type: { $ref: 'defs.json#/definitions/MessageWarningTypeApi' },
        reason_type: { $ref: 'defs.json#/definitions/RemovalReasonApi' },
        annotator_user_id: { type: 'number' },
        time_created: { type: 'number' },
        time_closed: { type: 'number' },
        reason: { type: 'string' },
      },
      required: [
        'annotator_user_id',
        'message_id',
        'reason_type',
        'thread_id',
        'warning_type',
      ],
    },
    MessageWarningTypeApi: { enum: ['admin', 'none'], type: 'string' },
    ThreadEventApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        thread_id: { type: 'number' },
        time_created: { type: 'number' },
        event_type: { $ref: 'defs.json#/definitions/ThreadEventTypeApi' },
        user_id: { type: 'number' },
        context: { $ref: 'defs.json#/definitions/ContextApi_1' },
      },
      required: ['event_type', 'thread_id', 'time_created'],
    },
    ThreadEventTypeApi: {
      enum: ['join_group_chat', 'leave_group_chat'],
      type: 'string',
    },
    ContextDetailsApi_1: {
      type: 'object',
      properties: {
        projects: {
          type: 'object',
          additionalProperties: false,
          patternProperties: {
            '^[0-9]+$': { $ref: 'defs.json#/definitions/ProjectApi' },
          },
        },
        contests: {
          type: 'object',
          additionalProperties: false,
          patternProperties: {
            '^[0-9]+$': { $ref: 'defs.json#/definitions/ContestApi' },
          },
        },
        prehires: {
          type: 'object',
          additionalProperties: false,
          patternProperties: {
            '^[0-9]+$': { $ref: 'defs.json#/definitions/PrehireApi' },
          },
        },
        support_sessions: {
          type: 'object',
          additionalProperties: false,
          patternProperties: {
            '^[0-9]+$': { $ref: 'defs.json#/definitions/SupportSessionApi' },
          },
        },
        sessions: {
          type: 'object',
          additionalProperties: false,
          patternProperties: {
            '^[0-9]+$': { $ref: 'defs.json#/definitions/SessionApi' },
          },
        },
      },
      required: ['contests', 'prehires', 'projects', 'support_sessions'],
    },
    PrehireApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        project_id: { type: 'number' },
        employer_id: { type: 'number' },
        freelancer_id: { type: 'number' },
      },
      required: ['employer_id', 'freelancer_id', 'id'],
    },
    SessionApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        user_id: { type: 'number' },
        support_type: { $ref: 'defs.json#/definitions/SupportTypeApi' },
        source: { $ref: 'defs.json#/definitions/SourceApi' },
        create_time: { type: 'number' },
      },
      required: ['create_time', 'id', 'source', 'support_type', 'user_id'],
    },
    SupportTypeApi: {
      enum: [
        'account_closure',
        'arrow_concierge',
        'awaiting_verification',
        'brief_improvement',
        'deposit_failure',
        'discover',
        'eqa',
        'expert_freelancer_screening',
        'freelancer_verified',
        'general',
        'local',
        'membership_curation',
        'meta_moderate',
        'offsite_messaging',
        'payment_satisfaction',
        'pfp_applications',
        'pfp_tickets',
        'pjp_assistant',
        'profile_picture_curation',
        'project_management',
        'project_quality_audit',
        'recruiter',
        'sales',
        'success_manager',
        'technical',
      ],
      type: 'string',
    },
    SourceApi: {
      type: 'object',
      properties: {
        type: { $ref: 'defs.json#/definitions/SourceTypeApi_1' },
        id: { type: 'number' },
      },
      required: ['id', 'type'],
    },
    SourceTypeApi_1: {
      enum: ['invoice', 'offsite', 'project', 'ticket', 'transaction', 'user'],
      type: 'string',
    },
    WebscoketAddProjectCollaboratorEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['addProjectCollaborator'] },
        data: { $ref: 'defs.json#/definitions/ProjectCollaborationApi' },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAcceptDisputeOfferEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['acceptDisputeOffer'] },
        data: {
          type: 'object',
          properties: {
            dispute_id: { type: 'string' },
            id: { type: 'number' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            userId: { type: 'string' },
            userName: { type: 'string' },
          },
          required: [
            'dispute_id',
            'id',
            'linkUrl',
            'name',
            'publicName',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAcceptedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['accepted'] },
        data: {
          type: 'object',
          properties: {
            apiMessage: {
              $ref: 'defs.json#/definitions/BidWebsocketApiMessage',
            },
            bid: {
              type: 'object',
              properties: {
                retracted: { type: 'boolean' },
                descr: { type: ['null', 'string'] },
                id: { type: 'number' },
              },
              required: ['descr', 'id', 'retracted'],
            },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            isAutomaticPayments: { type: 'boolean' },
            isHourly: { type: 'boolean' },
            milestoneCreated: { type: 'boolean' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            userName: { type: 'string' },
            userId: { type: 'number' },
            awardeeName: { type: 'string' },
            awardeeId: { type: 'number' },
            bidId: { type: 'number' },
            milestoneIds: { type: 'array', items: { type: 'number' } },
            projectType: {
              $ref: 'defs.json#/definitions/NotificationProjectType',
            },
          },
          required: [
            'apiMessage',
            'awardeeId',
            'awardeeName',
            'bid',
            'bidId',
            'id',
            'img',
            'isAutomaticPayments',
            'isHourly',
            'milestoneCreated',
            'milestoneIds',
            'name',
            'projectType',
            'publicName',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    BidWebsocketApiMessage: {
      type: 'object',
      properties: {
        bid: {
          type: 'object',
          properties: {
            amount: { type: 'number' },
            award_status: { $ref: 'defs.json#/definitions/BidAwardStatusApi' },
            complete_status: {
              $ref: 'defs.json#/definitions/BidCompleteStatusApi',
            },
            bidder_id: { type: 'number' },
            id: { type: 'number' },
            period: { type: 'number' },
          },
          required: [
            'award_status',
            'bidder_id',
            'complete_status',
            'id',
            'period',
          ],
        },
        project: {
          type: 'object',
          properties: {
            currency: {
              type: 'object',
              properties: {
                code: { type: 'string' },
                id: { type: 'number' },
                sign: { type: 'string' },
              },
              required: ['code', 'id', 'sign'],
            },
            id: { type: 'number' },
            owner_id: { type: 'number' },
            title: { type: 'string' },
          },
          required: ['id', 'owner_id'],
        },
        users: {
          type: 'object',
          additionalProperties: {
            type: 'object',
            properties: { username: { type: 'string' } },
            required: ['username'],
          },
        },
      },
      required: ['bid', 'project'],
    },
    BidAwardStatusApi: {
      enum: ['awarded', 'canceled', 'pending', 'rejected', 'revoked'],
      type: 'string',
    },
    BidCompleteStatusApi: {
      enum: ['complete', 'incomplete', 'pending'],
      type: 'string',
    },
    NotificationProjectType: { enum: ['hireMe', 'normal'], type: 'string' },
    WebsocketActivateFreelancerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['activateFreelancer'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            key: { type: 'string' },
            updatedProfile: { type: 'string' },
            verifiedEmail: { type: 'string' },
          },
          required: ['id', 'key', 'updatedProfile', 'verifiedEmail'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAdminForceVerifyPhoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['adminForceVarifyPhone'] },
        data: {
          type: 'object',
          properties: {
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
          },
          required: ['img'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketArticleCommentEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['articleCommentReceived'] },
        data: {
          type: 'object',
          properties: {
            article_author: { type: ['string', 'number'] },
            article_name: { type: 'string' },
            article_type: { type: 'string' },
            comment_by: { type: ['string', 'number'] },
            comment_date: {
              anyOf: [
                {
                  type: 'object',
                  properties: {
                    timezone_type: { type: 'number' },
                    date: { type: 'string' },
                    timezone: { type: 'string' },
                  },
                  required: ['date', 'timezone', 'timezone_type'],
                },
                { type: 'string' },
              ],
            },
            comment_id: { type: ['string', 'number'] },
            comment: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            publicName: { type: 'string' },
            user: { type: 'string' },
          },
          required: [
            'article_author',
            'article_name',
            'article_type',
            'comment',
            'comment_by',
            'comment_date',
            'comment_id',
            'id',
            'imgUrl',
            'linkUrl',
            'publicName',
            'user',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAwardBadgeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['awardBadge'] },
        data: {
          type: 'object',
          properties: {
            descr: { type: 'string' },
            id: { type: 'number' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
          },
          required: ['descr', 'id', 'linkUrl', 'name'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAwardCreditEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['awardCredit'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: ['string', 'number'] },
            id: { type: ['string', 'number'] },
            linkUrl: { type: 'string' },
          },
          required: ['amount', 'id', 'linkUrl'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAwardEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['award'] },
        state: { type: 'string' },
        data: {
          type: 'object',
          properties: {
            acceptByTime: { type: 'number' },
            actionText: { type: 'string' },
            apiMessage: {
              type: 'object',
              properties: {
                bid: {
                  type: 'object',
                  properties: {
                    amount: { type: 'number' },
                    award_status: { type: 'string', enum: ['pending'] },
                    bidder_id: { type: 'number' },
                    id: { type: 'number' },
                    period: { type: 'number' },
                  },
                  required: [
                    'amount',
                    'award_status',
                    'bidder_id',
                    'id',
                    'period',
                  ],
                },
                project: {
                  type: 'object',
                  properties: {
                    currency: {
                      type: 'object',
                      properties: {
                        code: { type: 'string' },
                        sign: { type: 'string' },
                      },
                      required: ['code', 'sign'],
                    },
                    id: { type: 'number' },
                    owner_id: { type: 'number' },
                    title: { type: 'string' },
                    type: { enum: ['fixed', 'hourly'], type: 'string' },
                  },
                  required: ['currency', 'id', 'owner_id', 'title', 'type'],
                },
                users: {
                  type: 'object',
                  additionalProperties: {
                    type: 'object',
                    properties: { username: { type: 'string' } },
                    required: ['username'],
                  },
                },
              },
              required: ['bid', 'project', 'users'],
            },
            appended_descr: { type: 'string' },
            awardeeId: { type: 'number' },
            awardeeName: { type: 'string' },
            bid: {
              type: 'object',
              properties: {
                bidAmount: { type: 'string' },
                bidDescr: { type: ['null', 'string'] },
                bidId: { type: 'number' },
                bidPeriod: { type: 'string' },
                id: { type: 'number' },
              },
              required: ['bidAmount', 'bidDescr', 'bidId', 'bidPeriod', 'id'],
            },
            categoryName: { type: 'string' },
            currencycode: { type: 'string' },
            currencysign: { type: 'string' },
            id: { type: 'number' },
            imgUrl: { type: 'string' },
            isTest: { type: 'boolean' },
            jobs: { type: 'array', items: { type: 'string' } },
            jobString: { type: 'string' },
            linkUrl: { type: 'string' },
            publicName: { type: 'string' },
            projIsHourly: { type: 'boolean' },
            text: { type: 'string' },
            title: { type: 'string' },
            userId: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'apiMessage',
            'appended_descr',
            'bid',
            'currencycode',
            'currencysign',
            'id',
            'jobString',
            'jobs',
            'projIsHourly',
            'publicName',
            'title',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAwardMilestoneReminderEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['awardMilestoneReminder'] },
        data: {
          type: 'object',
          properties: {
            appended_descr: { type: 'string' },
            currencycode: { type: 'string' },
            currencyid: { type: ['string', 'number'] },
            currencysign: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            projIsHourly: { type: 'boolean' },
            publicName: { type: 'string' },
            title: { type: 'string' },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
          },
          required: [
            'appended_descr',
            'currencycode',
            'currencyid',
            'currencysign',
            'id',
            'imgUrl',
            'linkUrl',
            'projIsHourly',
            'title',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAwardReminderEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['awardReminder'] },
        data: {
          type: 'object',
          properties: {
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            userName: { type: 'string' },
            bid: {
              type: 'object',
              properties: { id: { type: ['string', 'number'] } },
              required: ['id'],
            },
          },
          required: ['bid', 'imgUrl', 'linkUrl', 'name', 'userName'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketAwardXpEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['awardXp'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: ['string', 'number'] },
            descr: { type: 'string' },
            game: { type: 'string', enum: ['xp'] },
            id: { type: ['string', 'number'] },
            linkUrl: { type: 'string' },
          },
          required: ['amount', 'descr', 'game', 'id', 'linkUrl'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketBalanceUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['balanceUpdate'] },
        data: {
          type: 'object',
          properties: {
            balances: {
              type: 'array',
              items: { $ref: 'defs.json#/definitions/BalanceApi' },
            },
            primary_currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
          },
          required: ['balances', 'primary_currency'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketBidEvent: {
      type: 'object',
      properties: {
        type: { enum: ['bid', 'bid_self', 'bid_updated'], type: 'string' },
        data: {
          type: 'object',
          properties: {
            accountId: { type: 'number' },
            amount: { type: 'string' },
            award: { type: 'string' },
            bidAvg: {
              anyOf: [
                { enum: [false], type: 'boolean' },
                { type: ['string', 'number'] },
              ],
            },
            bidCount: { type: 'number' },
            bidHidden: { type: 'boolean' },
            bidNo: {
              anyOf: [
                { enum: [false], type: 'boolean' },
                { type: ['null', 'string'] },
              ],
            },
            buyerFeePerDollar: { type: 'string' },
            buyerMinProjectFee: { type: 'string' },
            categoryName: { type: 'string' },
            currency: { type: 'string' },
            currencyCode: { type: 'string' },
            currencyId: { type: 'string' },
            descr: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            initMilestone: { type: 'number' },
            linkUrl: { type: 'string' },
            period: { type: 'string' },
            pmb: {},
            projectId: { type: ['string', 'number'] },
            projIsFullTime: { type: 'boolean' },
            projIsHourly: { type: 'boolean' },
            projName: { type: 'string' },
            publicName: { type: 'string' },
            showAwardFee: { type: 'boolean' },
            text: { type: 'string' },
            title: { type: 'string' },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
            userBalances: {
              anyOf: [
                {
                  type: 'object',
                  properties: {
                    all: {
                      anyOf: [
                        {
                          type: 'array',
                          items: {
                            type: 'object',
                            properties: {
                              currency: {
                                type: 'object',
                                properties: {
                                  code: { type: 'string' },
                                  country: { type: 'string' },
                                  exchangerate: { type: 'string' },
                                  id: { type: 'string' },
                                  is_external: { type: 'string' },
                                  name: { type: 'string' },
                                  seq: { type: 'string' },
                                  sign: { type: 'string' },
                                },
                                required: [
                                  'code',
                                  'country',
                                  'exchangerate',
                                  'id',
                                  'name',
                                  'seq',
                                  'sign',
                                ],
                              },
                              balance: { type: 'string' },
                            },
                            required: ['balance', 'currency'],
                          },
                        },
                        { type: 'null' },
                      ],
                    },
                    relevant: { type: 'number' },
                  },
                  required: ['all', 'relevant'],
                },
                { type: 'null' },
              ],
            },
            bid: {
              type: 'object',
              properties: {
                award_score: { type: 'number' },
                completed: { type: 'boolean' },
                completion_score: { type: 'number' },
                descr_html: { type: 'string' },
                descr_short_html: { type: 'string' },
                descr_short: { type: 'string' },
                descr: { type: ['null', 'string'] },
                highlighted: { type: ['null', 'boolean'] },
                id: { type: ['string', 'number'] },
                isShortlisted: { type: ['null', 'boolean'] },
                milestone_percentage: { type: ['string', 'number'] },
                no: {
                  anyOf: [
                    { enum: [false], type: 'boolean' },
                    { type: ['null', 'string'] },
                  ],
                },
                paid_status: {
                  anyOf: [{ enum: [false], type: 'boolean' }, { type: 'null' }],
                },
                period: { type: 'string' },
                project_id: { type: ['string', 'number'] },
                r2: { type: 'number' },
                ranking: { type: 'number' },
                score: { type: 'number' },
                sponsored: { type: ['null', 'boolean'] },
                submitdate_f: { type: 'string' },
                submitdate_f2: { type: 'string' },
                submitdate_ts: { type: 'number' },
                submitdate: { type: 'string' },
                sum: { type: 'string' },
                users_id: { type: 'number' },
                user: {
                  type: 'object',
                  properties: {
                    address: {
                      type: 'object',
                      properties: {
                        country: { type: ['null', 'string'] },
                        code: { type: 'string' },
                        city: { type: ['null', 'string'] },
                      },
                      required: ['city', 'code', 'country'],
                    },
                    company: { type: ['null', 'string'] },
                    currency: { type: 'number' },
                    earnings: { type: ['string', 'number'] },
                    flag_class: { type: 'string' },
                    flag_name: { type: ['null', 'string'] },
                    flag: {
                      type: 'object',
                      properties: {
                        name: { type: ['null', 'string'] },
                        icon: { type: 'string' },
                      },
                      required: ['icon', 'name'],
                    },
                    gold: { type: 'number' },
                    hourlyrate: { type: ['null', 'number'] },
                    id: { type: 'number' },
                    insignia: {
                      type: 'array',
                      items: {
                        type: 'object',
                        properties: {
                          name: { type: 'string' },
                          title: { type: 'string' },
                          examEnabled: { type: ['null', 'string'] },
                          examId: { type: ['null', 'string'] },
                          id: { type: 'string' },
                          description: { type: 'string' },
                        },
                        required: [
                          'description',
                          'examEnabled',
                          'examId',
                          'id',
                          'name',
                          'title',
                        ],
                      },
                    },
                    isPortfolioCreated: { type: 'boolean' },
                    jobs: { type: 'array', items: { type: 'string' } },
                    logo_Url: { type: 'string' },
                    normalMemberclassLogo: { type: 'string' },
                    online: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string'] },
                      ],
                    },
                    profile_logo_Url: { type: 'string' },
                    provider_rating: {
                      type: 'object',
                      properties: {
                        count: { type: 'number' },
                        avg: { type: ['string', 'number'] },
                      },
                      required: ['avg', 'count'],
                    },
                    publicName: { type: 'string' },
                    rating: {
                      type: 'object',
                      properties: {
                        count: { type: 'number' },
                        avg: { type: ['string', 'number'] },
                      },
                      required: ['avg', 'count'],
                    },
                    reg_date: { type: 'string' },
                    reputation_rate: { type: 'number' },
                    timezone_info: {
                      $ref: 'defs.json#/definitions/TimezoneApi',
                    },
                    tooltipMemberclassLogo: { type: 'string' },
                    Url: { type: 'string' },
                    username: { type: 'string' },
                    seller_rating: {
                      $ref:
                        'defs.json#/definitions/WebsocketBidEventSellerRating',
                    },
                  },
                  required: [
                    'address',
                    'company',
                    'currency',
                    'earnings',
                    'flag',
                    'flag_class',
                    'flag_name',
                    'gold',
                    'hourlyrate',
                    'id',
                    'insignia',
                    'isPortfolioCreated',
                    'jobs',
                    'normalMemberclassLogo',
                    'provider_rating',
                    'rating',
                    'reg_date',
                    'reputation_rate',
                    'seller_rating',
                    'tooltipMemberclassLogo',
                    'username',
                  ],
                },
              },
              required: ['id'],
            },
          },
          required: [
            'amount',
            'bid',
            'bidHidden',
            'currency',
            'currencyCode',
            'currencyId',
            'descr',
            'id',
            'imgUrl',
            'period',
            'pmb',
            'projIsFullTime',
            'projIsHourly',
            'projName',
            'projectId',
            'showAwardFee',
            'title',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketBidEventSellerRating: {
      type: 'object',
      properties: {
        count: { type: 'number' },
        projectCount: {
          type: 'object',
          properties: {
            last12months: {
              $ref: 'defs.json#/definitions/WebsocketBidEventProjectCount',
            },
            last3months: {
              $ref: 'defs.json#/definitions/WebsocketBidEventProjectCount',
            },
            entire_history: {
              $ref: 'defs.json#/definitions/WebsocketBidEventProjectCount',
            },
          },
          required: ['entire_history', 'last12months', 'last3months'],
        },
        completionRate: { type: 'number' },
        avg: { type: 'number' },
        reputation: {
          type: 'object',
          properties: {
            last12months: {
              $ref: 'defs.json#/definitions/WebsocketBidEventReputation',
            },
            last3months: {
              $ref: 'defs.json#/definitions/WebsocketBidEventReputation',
            },
            entire_history: {
              $ref: 'defs.json#/definitions/WebsocketBidEventReputation',
            },
          },
          required: ['entire_history', 'last12months', 'last3months'],
        },
      },
      required: [
        'avg',
        'completionRate',
        'count',
        'projectCount',
        'reputation',
      ],
    },
    WebsocketBidEventProjectCount: {
      type: 'object',
      properties: {
        all: { type: 'number' },
        incomplete_reviews: { type: 'number' },
        complete: { type: 'number' },
        completion_rate: { type: 'number' },
        reviews: { type: 'number' },
        earnings: { type: 'number' },
        incomplete: { type: 'number' },
      },
      required: [
        'all',
        'complete',
        'completion_rate',
        'earnings',
        'incomplete',
        'incomplete_reviews',
        'reviews',
      ],
    },
    WebsocketBidEventReputation: {
      type: 'object',
      properties: {
        com: { type: 'number' },
        exp: { type: 'number' },
        hag: { type: 'number' },
        onb: { type: 'number' },
        ont: { type: 'number' },
        overall: { type: 'number' },
        pos: { type: 'number' },
        pro: { type: 'number' },
        qua: { type: 'number' },
      },
      required: [
        'com',
        'exp',
        'hag',
        'onb',
        'ont',
        'overall',
        'pos',
        'pro',
        'qua',
      ],
    },
    WebsocketBidHourlyCurrentCycleSummaryUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['bidHourlyCurrentCycleSummaryUpdate'] },
        data: {
          type: 'object',
          properties: {
            bidId: { type: 'number' },
            totalTrackedTime: { type: 'number' },
            totalUninvoicedTime: { type: 'number' },
          },
          required: ['bidId', 'totalTrackedTime', 'totalUninvoicedTime'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketBidretractedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['bidretracted'] },
        data: {
          type: 'object',
          properties: {
            bid_amount: { type: 'number' },
            bid_id: { type: 'number' },
            project_id: { type: 'number' },
            seller_id: { type: 'number' },
          },
          required: ['bid_amount', 'bid_id', 'project_id', 'seller_id'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketCancelMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['cancelMilestone'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            tranId: { type: ['string', 'number'] },
          },
          required: ['id', 'tranId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketCompleteContestReviewEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['completeContestReview'] },
        data: {
          type: 'object',
          properties: {
            userId: { type: 'number' },
            userName: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            message: { type: 'string' },
            rating: { type: 'string' },
            img: {
              type: 'object',
              properties: { logo_url: { type: ['string', 'boolean'] } },
            },
            seoUrl: { type: 'string' },
          },
          required: [
            'message',
            'name',
            'publicName',
            'rating',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketCompleteReviewEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['completeReview'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            invoice_id: { type: ['null', 'number'] },
            message: { type: 'string' },
            name: { type: 'string' },
            private: { type: 'boolean' },
            publicName: { type: 'string' },
            rating: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            userName: { type: 'string' },
            userId: { type: 'number' },
          },
          required: [
            'id',
            'img',
            'invoice_id',
            'message',
            'name',
            'private',
            'publicName',
            'rating',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestAwardedToEmployerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestAwardedToEmployer'] },
        data: {
          type: 'object',
          properties: {
            contestName: { type: 'string' },
            contestSEOURL: { type: 'string' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            entry_id: { type: 'string' },
            entry_number: { type: 'string' },
            entryCount: { type: 'string' },
            freelancerCount: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            isBought: { type: 'boolean' },
            linkUrl: { type: 'string' },
            prize: { type: ['string', 'number'] },
            publicName: { type: 'string' },
            thumb: { type: 'string' },
            userId: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'contestName',
            'currencyCode',
            'currencySign',
            'entryCount',
            'entry_id',
            'entry_number',
            'freelancerCount',
            'id',
            'imgUrl',
            'isBought',
            'linkUrl',
            'prize',
            'thumb',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestAwardedToFreelancerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestAwardedToFreelancer'] },
        data: {
          type: 'object',
          properties: {
            contestName: { type: 'string' },
            contestSEOURL: { type: 'string' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            entry_id: { type: ['string', 'number'] },
            entry_number: { type: ['string', 'number'] },
            entryCount: { type: ['string', 'number'] },
            freelancerCount: { type: ['string', 'number'] },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            prize: { type: ['string', 'number'] },
            publicName: { type: 'string' },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
            thumb: { type: 'string' },
          },
          required: [
            'contestName',
            'contestSEOURL',
            'currencyCode',
            'currencySign',
            'entryCount',
            'entry_id',
            'entry_number',
            'freelancerCount',
            'id',
            'imgUrl',
            'linkUrl',
            'prize',
            'thumb',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestCommentEvent: {
      type: 'object',
      properties: {
        type: {
          enum: [
            'contestCommentDeleted',
            'contestCommentPosted',
            'contestCommentUndeleted',
          ],
          type: 'string',
        },
        data: {
          type: 'object',
          properties: {
            commentId: { type: 'number' },
            parentCommentId: { type: 'number' },
          },
          required: ['commentId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestCompleteEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestComplete'] },
        data: {
          type: 'object',
          properties: {
            contest_name: { type: 'string' },
            contest_url: { type: 'string' },
            entry_id: { type: 'string' },
            imgUrl: { type: 'string' },
            public_name: { type: 'string' },
            review_id: { type: 'string' },
            to_freelancer: { type: 'boolean' },
            user_name: { type: 'string' },
          },
          required: [
            'contest_name',
            'contest_url',
            'entry_id',
            'imgUrl',
            'public_name',
            'review_id',
            'to_freelancer',
            'user_name',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestCreatedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestCreated'] },
        data: {
          type: 'object',
          properties: {
            contest_name: { type: 'string' },
            contest_url: { type: 'string' },
            contest_id: { type: 'string' },
          },
          required: ['contest_id', 'contest_name', 'contest_url'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryBoughtToEmployerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryBoughtToEmployer'] },
        data: {
          type: 'object',
          properties: {
            contestName: { type: 'string' },
            entry_id: { type: ['string', 'number'] },
            entry_number: { type: ['string', 'number'] },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            publicName: { type: 'string' },
            userName: { type: 'string' },
          },
          required: [
            'contestName',
            'entry_id',
            'entry_number',
            'id',
            'imgUrl',
            'linkUrl',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryBoughtToFreelancerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryBoughtToFreelancer'] },
        data: {
          type: 'object',
          properties: {
            contestName: { type: 'string' },
            entry_id: { type: ['string', 'number'] },
            entry_number: { type: ['string', 'number'] },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            publicName: { type: 'string' },
            userName: { type: 'string' },
          },
          required: [
            'contestName',
            'entry_id',
            'entry_number',
            'id',
            'imgUrl',
            'linkUrl',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryCommentedToFreelancerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryCommentedToFreelancer'] },
        data: {
          type: 'object',
          properties: {
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            entryNumber: { type: 'string' },
            id: { type: 'string' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
          },
          required: [
            'contestId',
            'contestName',
            'entryNumber',
            'id',
            'imgUrl',
            'linkUrl',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryCreatedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryCreated'] },
        data: {
          type: 'object',
          properties: {
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            contestSeoUrl: { type: 'string' },
            entryUrl: { type: 'string' },
            freelancerId: { type: ['string', 'number'] },
            freelancerImg: {
              type: 'object',
              properties: { logo_url: { type: ['string', 'boolean'] } },
            },
            freelancerName: { type: 'string' },
            freelancerPublicName: { type: 'string' },
            entryNumber: { type: 'string' },
            entryThumb: { type: 'string' },
            entryS3path: { type: 'string' },
            entryId: { type: ['string', 'number'] },
            userId: { type: ['string', 'number'] },
            time: { type: 'number' },
            sellPrice: { type: 'number' },
            entryThumbName: { type: 'string' },
            entryTitle: { type: 'string' },
            entryFiles: {
              type: 'array',
              items: { $ref: 'defs.json#/definitions/ContestEntryFile' },
            },
            status: {
              $ref: 'defs.json#/definitions/ContestEntryStatusWebsocketEvent',
            },
            upgrades: { $ref: 'defs.json#/definitions/EntryUpgradesApi' },
            timeEntered: { type: 'number' },
            employerId: { type: 'string' },
          },
          required: [
            'contestId',
            'contestName',
            'contestSeoUrl',
            'employerId',
            'entryFiles',
            'entryId',
            'entryNumber',
            'entryS3path',
            'entryThumb',
            'entryThumbName',
            'entryTitle',
            'entryUrl',
            'freelancerId',
            'freelancerName',
            'freelancerPublicName',
            'sellPrice',
            'status',
            'time',
            'timeEntered',
            'upgrades',
            'userId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    ContestEntryFile: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        fileUrl: { type: 'string' },
        thumbnailUrl: { type: 'string' },
        thumbnail420Url: { type: 'string' },
        thumbnail900Url: { type: 'string' },
        thumbnail80Url: { type: 'string' },
        thumbnail80FixUrl: { type: 'string' },
        thumbnailDigestUrl: { type: 'string' },
        thumbnailPreview: { type: 'string' },
      },
      required: ['id', 'name'],
    },
    ContestEntryStatusWebsocketEvent: {
      description:
        'Used on server notifications model since entry-related websocket events\nsends the status as a text.',
      enum: ['Active', 'Bought', 'Eliminated', 'Withdrawn', 'Won'],
      type: 'string',
    },
    WebsocketContestEntryEngagedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryEngaged'] },
        data: {
          type: 'object',
          properties: {
            contestId: { type: 'number' },
            totalEngageableEntries: { type: 'number' },
            unratedEntries: { type: 'number' },
            engagementRatio: { type: 'number' },
          },
          required: [
            'contestId',
            'engagementRatio',
            'totalEngageableEntries',
            'unratedEntries',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntry'] },
        data: {
          type: 'object',
          properties: {
            contestHolder: { type: 'string' },
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            firstUser: { type: 'string' },
            firstUserPublicName: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            secondUser: { type: ['null', 'string'] },
            secondUserPublicName: { type: ['null', 'string'] },
            userId: { type: ['string', 'number'] },
          },
          required: [
            'contestHolder',
            'contestId',
            'contestName',
            'id',
            'imgUrl',
            'linkUrl',
            'userId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryRatedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryRated'] },
        data: {
          type: 'object',
          properties: {
            contestId: { type: ['string', 'number'] },
            contestName: { type: 'string' },
            contestSeoUrl: { type: 'string' },
            employerImg: {
              type: 'object',
              properties: { logo_url: { type: ['string', 'boolean'] } },
            },
            employerName: { type: 'string' },
            employerPublicName: { type: 'string' },
            entryId: { type: ['string', 'number'] },
            entryNumber: { type: 'string' },
            entryThumb: { type: 'string' },
            entryUrl: { type: 'string' },
            rating: { type: 'string' },
            time: { type: 'number' },
          },
          required: [
            'contestId',
            'contestName',
            'contestSeoUrl',
            'employerName',
            'employerPublicName',
            'entryId',
            'entryNumber',
            'entryThumb',
            'entryUrl',
            'rating',
            'time',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryRatedToFreelancerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryRatedToFreelancer'] },
        data: {
          type: 'object',
          properties: {
            action: { type: 'string' },
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            employerId: { type: 'string' },
            entriesUrl: { type: 'string' },
            entryId: { type: 'string' },
            entryNumber: { type: 'string' },
            entryS3path: { type: 'string' },
            entryThumb: { type: 'string' },
            entryUrl: { type: 'string' },
            freelancerId: { type: 'string' },
            hasOtherEntriesRatedOrRejected: { type: 'boolean' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            ratedOrRejectedEntriesCount: { type: 'number' },
            rating: { type: 'string' },
          },
          required: [
            'action',
            'contestId',
            'contestName',
            'employerId',
            'entriesUrl',
            'entryId',
            'entryNumber',
            'entryS3path',
            'entryThumb',
            'entryUrl',
            'freelancerId',
            'hasOtherEntriesRatedOrRejected',
            'imgUrl',
            'linkUrl',
            'ratedOrRejectedEntriesCount',
            'rating',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryReconsideredToFreelancerEvent: {
      type: 'object',
      properties: {
        type: {
          type: 'string',
          enum: ['contestEntryReconsideredToFreelancer'],
        },
        data: {
          type: 'object',
          properties: {
            action: { type: 'string' },
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            employerId: { type: 'string' },
            entriesUrl: { type: 'string' },
            entryId: { type: 'string' },
            entryNumber: { type: 'string' },
            entryS3path: { type: 'string' },
            entryThumb: { type: 'string' },
            entryUrl: { type: 'string' },
            freelancerId: { type: 'string' },
            hasOtherEntriesRatedOrRejected: { type: 'boolean' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            ratedOrRejectedEntriesCount: { type: 'number' },
            rating: { type: 'string' },
          },
          required: [
            'action',
            'contestId',
            'contestName',
            'employerId',
            'entriesUrl',
            'entryId',
            'entryNumber',
            'entryS3path',
            'entryThumb',
            'entryUrl',
            'freelancerId',
            'hasOtherEntriesRatedOrRejected',
            'imgUrl',
            'linkUrl',
            'ratedOrRejectedEntriesCount',
            'rating',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEntryRejectedToFreelancerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestEntryRejectedToFreelancer'] },
        data: {
          type: 'object',
          properties: {
            action: { type: 'string' },
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            employerId: { type: 'string' },
            entriesUrl: { type: 'string' },
            entryId: { type: 'string' },
            entryNumber: { type: 'string' },
            entryS3path: { type: 'string' },
            entryThumb: { type: 'string' },
            entryUrl: { type: 'string' },
            freelancerId: { type: 'string' },
            hasOtherEntriesRatedOrRejected: { type: 'boolean' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            ratedOrRejectedEntriesCount: { type: 'number' },
            rating: { type: 'string' },
          },
          required: [
            'action',
            'contestId',
            'contestName',
            'employerId',
            'entriesUrl',
            'entryId',
            'entryNumber',
            'entryS3path',
            'entryThumb',
            'entryUrl',
            'freelancerId',
            'hasOtherEntriesRatedOrRejected',
            'imgUrl',
            'linkUrl',
            'ratedOrRejectedEntriesCount',
            'rating',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contest'] },
        data: {
          allOf: [
            { $ref: 'defs.json#/definitions/TimeSeconds' },
            {
              type: 'object',
              properties: {
                id: { type: ['string', 'number'] },
                actionText: {},
                appended_descr: { type: 'string' },
                buyer: { type: 'string' },
                buyerUrl: { type: 'string' },
                imgUrl: { type: 'string' },
                isTest: { type: 'boolean' },
                jobs: {
                  anyOf: [
                    { type: 'array', items: { type: 'string' } },
                    { type: 'array', items: { type: 'number' } },
                  ],
                },
                jobString: { type: 'string' },
                linkUrl: { type: 'string' },
                title: { type: 'string' },
                userId: { type: 'string' },
                userName: { type: 'string' },
              },
              required: [
                'actionText',
                'appended_descr',
                'buyer',
                'buyerUrl',
                'id',
                'imgUrl',
                'isTest',
                'jobString',
                'jobs',
                'linkUrl',
                'title',
                'userId',
                'userName',
              ],
            },
            {
              type: 'object',
              properties: {
                currency: { type: 'string' },
                currencyCode: { type: 'string' },
                exchangerate: { type: 'string' },
                extended: { type: 'boolean' },
                featured: { type: 'boolean' },
                free_bid_until: { type: 'number' },
                highlight: {},
                maxbudget: { type: ['string', 'number'] },
                private: { type: 'boolean' },
                sealed: { type: 'boolean' },
                submitDate: { type: 'string' },
              },
              required: [
                'currencyCode',
                'exchangerate',
                'extended',
                'featured',
                'highlight',
                'private',
                'sealed',
                'submitDate',
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    TimeSeconds: {
      description:
        'A crude way to check if a time is in seconds or milliseconds.\nUsed in backend models (*.backend-model.ts and server-message-event.model.ts)\nto validate the format of times.\n\nThis assumes timestamps are within a certain interval.\n2000-01-01 — 2100-01-01 is:\n946,684,800 — 4,102,444,800 in seconds\n946,684,800,000 — 4,102,444,800,000 in seconds\n\nRounding these numbers a bit gives:\n   500_000_000 1985-11-05\n5_000_000_000 2128-06-11',
      type: 'object',
      properties: {
        time: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['time'],
    },
    WebsocketContestExpiredEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestExpired'] },
        data: {
          type: 'object',
          properties: {
            contest_end_date: { type: 'number' },
            contest_name: { type: 'string' },
            contest_url: { type: 'string' },
            isExtended: { type: 'string' },
          },
          required: [
            'contest_end_date',
            'contest_name',
            'contest_url',
            'isExtended',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestPCBEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contest_pcb'] },
        data: {
          type: 'object',
          properties: {
            contestName: { type: 'string' },
            seoUrl: { type: 'string' },
            userPublicName: { type: 'string' },
            username: { type: 'string' },
            imgUrl: { type: 'string' },
            contestId: { type: 'string' },
          },
          required: [
            'contestId',
            'contestName',
            'seoUrl',
            'userPublicName',
            'username',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestPCBNotificationEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestPCBNotification'] },
        data: {
          type: 'object',
          properties: {
            contestHolder: { type: 'string' },
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            firstUser: { type: 'string' },
            firstUserPublicName: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            secondUser: { type: ['null', 'string'] },
            secondUserPublicName: { type: ['null', 'string'] },
            userId: { type: 'number' },
            userCount: { type: 'number' },
          },
          required: [
            'contestHolder',
            'contestId',
            'contestName',
            'id',
            'imgUrl',
            'linkUrl',
            'userCount',
            'userId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestPCBNotificationFullViewEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestPCBNotificationFullView'] },
        data: {
          type: 'object',
          properties: {
            contestHolder: { type: ['string', 'number'] },
            contestName: { type: 'string' },
            entryNumber: { type: ['null', 'string', 'number'] },
            firstUser: { type: 'string' },
            firstUserPublicName: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            secondUser: { type: ['null', 'string'] },
            secondUserPublicName: { type: ['null', 'string'] },
            userId: { type: ['string', 'number'] },
            userCount: { type: 'number' },
          },
          required: [
            'contestHolder',
            'contestName',
            'entryNumber',
            'firstUser',
            'id',
            'imgUrl',
            'linkUrl',
            'userCount',
            'userId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestReviewPostedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestreviewposted'] },
        state: { type: 'string' },
        data: {
          type: 'object',
          properties: {
            id: { type: ['string', 'number'] },
            img: {
              type: 'object',
              properties: { logo_url: { type: ['string', 'boolean'] } },
            },
            name: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: 'string' },
            userId: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'id',
            'name',
            'publicName',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketContestUpgradedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['contestUpgraded'] },
        data: {
          type: 'object',
          properties: {
            contest_id: { type: 'number' },
            new_upgrade: { $ref: 'defs.json#/definitions/ContestUpgradeApi' },
            seo_url: { type: 'string' },
          },
          required: ['contest_id', 'new_upgrade', 'seo_url'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    ContestUpgradeApi: {
      enum: [
        'featured',
        'guaranteed',
        'highlight',
        'nda',
        'nonpublic',
        'sealed',
        'top_contest',
        'urgent',
      ],
      type: 'string',
    },
    WebsocketCreateMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['createMilestone'] },
        data: {
          allOf: [
            { $ref: 'defs.json#/definitions/WebsocketProjectData' },
            {
              type: 'object',
              properties: {
                account_id: { type: ['null', 'string', 'number'] },
                amount: { type: ['string', 'number'] },
                currencycode: { type: 'string' },
                currencysign: { type: 'string' },
                project_id: { type: ['null', 'string', 'number'] },
                publicName: { type: 'string' },
                shortDescr: { type: 'string' },
                transId: {
                  anyOf: [
                    { enum: [false], type: 'boolean' },
                    { type: ['null', 'string', 'number'] },
                  ],
                },
                newMilestone: {
                  $ref: 'defs.json#/definitions/WebsocketMilestone',
                },
                created_milestone_request_id: {
                  anyOf: [
                    { enum: [false], type: 'boolean' },
                    { type: ['null', 'string', 'number'] },
                  ],
                },
              },
              required: [
                'account_id',
                'amount',
                'created_milestone_request_id',
                'currencycode',
                'currencysign',
                'newMilestone',
                'project_id',
                'shortDescr',
                'transId',
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectData: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        actionText: { type: 'string' },
        appended_descr: { type: 'string' },
        imgUrl: { type: 'string' },
        isTest: { type: 'boolean' },
        jobs: {
          anyOf: [
            { type: 'array', items: { type: 'string' } },
            { type: 'null' },
          ],
        },
        jobString: { type: 'string' },
        linkUrl: { type: 'string' },
        recruiter: { type: 'boolean' },
        text: { type: 'string' },
        title: { type: 'string' },
        userId: { type: ['string', 'number'] },
        userName: { type: 'string' },
      },
      required: [
        'actionText',
        'appended_descr',
        'id',
        'imgUrl',
        'isTest',
        'jobString',
        'jobs',
        'linkUrl',
        'recruiter',
        'text',
        'title',
        'userId',
        'userName',
      ],
    },
    WebsocketMilestone: {
      type: 'object',
      properties: {
        transaction_id: { type: ['number', 'boolean'] },
        project_owner_id: { type: 'string' },
        bidder_id: { type: 'string' },
        amount: { type: 'number' },
        reason: {
          enum: [
            'full_payment',
            'other',
            'partial_payment',
            'partly_payment',
            'task_description',
          ],
          type: 'string',
        },
        other_reason: { type: 'string' },
        project_id: { type: ['string', 'number'] },
        bid_id: { type: 'number' },
        currency: { $ref: 'defs.json#/definitions/CurrencyAjax' },
        is_from_prepaid: { type: 'boolean' },
        status: {
          enum: [
            'canceled',
            'cleared',
            'disputed',
            'frozen',
            'pending',
            'pending_clearance',
            'pending_recipient_kyc',
            'requested_release',
            'unknown',
          ],
          type: 'string',
        },
        dispute_id: { type: ['null', 'string'] },
        time_created: { type: ['string', 'boolean'] },
      },
      required: ['dispute_id'],
    },
    CurrencyAjax: {
      description:
        'A supported currency, but from GAF.\nTODO: Unify this with `Currency` by normalising AJAX and REST API responses',
      type: 'object',
      properties: {
        id: { type: 'string' },
        name: { type: 'string' },
        code: { type: 'string' },
        country: { type: 'string' },
        is_external: { enum: [0, '0', 1, '1'] },
        seq: { type: 'string' },
        sign: { type: 'string' },
      },
      required: ['code', 'id', 'sign'],
    },
    WebsocketCustomAdminNotificationEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['customAdminNotification'] },
        data: {
          type: 'object',
          properties: {
            link_text: { type: 'string' },
            link_url: { type: 'string' },
            noti_description: { type: 'string' },
            noti_text: { type: 'string' },
            id: { type: 'string' },
          },
          required: [
            'id',
            'link_text',
            'link_url',
            'noti_description',
            'noti_text',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketDeniedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['denyed'] },
        data: {
          type: 'object',
          properties: {
            apiMessage: {
              type: 'object',
              properties: {
                project: {
                  type: 'object',
                  properties: {
                    id: { type: 'number' },
                    title: { type: 'string' },
                    owner_id: { type: 'number' },
                    currency: {
                      type: 'object',
                      properties: {
                        sign: { type: 'string' },
                        code: { type: 'string' },
                      },
                      required: ['code', 'sign'],
                    },
                  },
                  required: ['currency', 'id', 'owner_id', 'title'],
                },
                bid: {
                  type: 'object',
                  properties: {
                    bidder_id: { type: 'number' },
                    award_status: { type: 'string', enum: ['rejected'] },
                  },
                  required: ['award_status', 'bidder_id'],
                },
                users: {
                  type: 'object',
                  additionalProperties: {
                    type: 'object',
                    properties: { username: { type: 'string' } },
                    required: ['username'],
                  },
                },
              },
              required: ['bid', 'project', 'users'],
            },
            autoRepostProjectId: { type: ['string', 'number'] },
            autoRepostProjectName: { type: 'string' },
            bidId: { type: ['string', 'number'] },
            currencycode: { type: 'string' },
            currencyId: { type: ['string', 'number'] },
            currencysign: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            jobsURL: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            projectOfferId: { type: 'number' },
            projectType: {
              $ref: 'defs.json#/definitions/NotificationProjectType',
            },
            projIsHourly: {},
            publicName: { type: 'string' },
            reason: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
          },
          required: [
            'apiMessage',
            'bidId',
            'currencyId',
            'currencycode',
            'currencysign',
            'id',
            'imgUrl',
            'jobsURL',
            'linkUrl',
            'name',
            'projIsHourly',
            'projectType',
            'reason',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketDeprecatedNotificationsEvent: {
      description: 'Unsupported notifications events to be ignored.',
      type: 'object',
      properties: {
        type: {
          enum: [
            'bidHidden',
            'contactRequestReceived',
            'contactRequestSent',
            'sitesBinCreated',
            'sitesHandOverMessageSent',
            'sitesListingStatusChanged',
            'sitesMessageSent',
            'sitesOfferCreated',
            'tasklist_create',
          ],
          type: 'string',
        },
        data: {},
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketDirectTransferDoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['directTransferDone'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: 'string' },
            currencycode: { type: 'string' },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            name: { type: 'string' },
            otherReason: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            userName: { type: 'string' },
            userId: { type: 'string' },
          },
          required: [
            'amount',
            'currencycode',
            'id',
            'img',
            'name',
            'otherReason',
            'publicName',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketDraftContestEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['draftContest'] },
        data: {
          type: 'object',
          properties: {
            contestEditUrl: { type: 'string' },
            contestId: { type: 'string' },
            contestName: { type: 'string' },
            contestUrl: { type: 'string' },
            imgUrl: { type: 'string' },
            isPublished: { type: 'boolean' },
          },
          required: [
            'contestId',
            'contestName',
            'contestUrl',
            'imgUrl',
            'isPublished',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketDriveFileUploadEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['driveFileUpload'] },
        parent_type: { type: 'string', enum: ['notifications'] },
        data: {
          type: 'object',
          properties: {
            drive_file: { $ref: 'defs.json#/definitions/DriveFileApi' },
            context: { $ref: 'defs.json#/definitions/DriveFileContext' },
          },
          required: ['context', 'drive_file'],
        },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
        id: { type: 'string' },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    DriveFileApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        owner_id: { type: 'number' },
        display_name: { type: 'string' },
        file_type: { type: 'string' },
        file_size: { type: 'number' },
        public_permission: {
          $ref: 'defs.json#/definitions/DriveFilePublicPermissionApi',
        },
        time_deleted: { type: 'number' },
        deleted_by: { type: 'number' },
        time_created: { type: 'number' },
        time_updated: { type: 'number' },
        is_nda_hidden: { type: 'boolean' },
        arrow_details: { $ref: 'defs.json#/definitions/DriveArrowDetailsApi' },
      },
      required: [
        'display_name',
        'file_size',
        'file_type',
        'id',
        'owner_id',
        'public_permission',
        'time_created',
      ],
    },
    DriveFilePublicPermissionApi: {
      enum: ['private', 'public_read', 'public_read_logged_in'],
      type: 'string',
    },
    DriveArrowDetailsApi: {
      type: 'object',
      properties: { bom_id: { type: 'string' } },
    },
    DriveFileContext: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        type: { type: 'string', enum: ['project'] },
      },
      required: ['id', 'type'],
    },
    WebsocketEditAwardedBidAcceptedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['editAwardedBidAccepted'] },
        data: {
          type: 'object',
          properties: {
            buyerName: { type: 'string' },
            buyerPublicName: { type: 'string' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            projName: { type: 'string' },
            editBidDetails: {
              type: 'object',
              properties: {
                newAmount: { type: 'number' },
                newPeriod: { type: 'number' },
                oldAmount: { type: 'number' },
                oldPeriod: { type: 'number' },
                bidID: { type: 'number' },
                comment: { type: 'string' },
                id: { type: 'number' },
                requestTime: { type: 'number' },
                responseTime: {
                  anyOf: [
                    { enum: [false], type: 'boolean' },
                    { type: 'number' },
                  ],
                },
                status: {
                  $ref: 'defs.json#/definitions/BidEditRequestStatusApi',
                },
              },
              required: [
                'bidID',
                'comment',
                'id',
                'newAmount',
                'newPeriod',
                'oldAmount',
                'oldPeriod',
                'requestTime',
                'status',
              ],
            },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            linkUrl: { type: 'string' },
          },
          required: [
            'buyerName',
            'buyerPublicName',
            'currencyCode',
            'currencySign',
            'editBidDetails',
            'id',
            'img',
            'linkUrl',
            'projName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    BidEditRequestStatusApi: {
      enum: ['accepted', 'declined', 'pending'],
      type: 'string',
    },
    WebsocketEditAwardedBidCreatedEvent: {
      type: 'object',
      properties: {
        data: {
          type: 'object',
          properties: {
            buyerName: { type: 'string' },
            buyerPublicName: { type: 'string' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            projName: { type: 'string' },
            editBidDetails: {
              type: 'object',
              properties: {
                newAmount: { type: 'number' },
                newPeriod: { type: 'number' },
                oldAmount: { type: 'number' },
                oldPeriod: { type: 'number' },
                bidID: { type: 'number' },
                comment: { type: 'string' },
                id: { type: 'number' },
                requestTime: { type: 'number' },
                responseTime: {
                  anyOf: [
                    { enum: [false], type: 'boolean' },
                    { type: 'number' },
                  ],
                },
                status: {
                  $ref: 'defs.json#/definitions/BidEditRequestStatusApi',
                },
              },
              required: [
                'bidID',
                'comment',
                'id',
                'newAmount',
                'newPeriod',
                'oldAmount',
                'oldPeriod',
                'requestTime',
                'status',
              ],
            },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            linkUrl: { type: 'string' },
          },
          required: [
            'buyerName',
            'buyerPublicName',
            'currencyCode',
            'currencySign',
            'editBidDetails',
            'id',
            'img',
            'linkUrl',
            'projName',
          ],
        },
        type: { type: 'string', enum: ['editAwardedBidRequest'] },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketEditAwardedBidDeclinedEvent: {
      type: 'object',
      properties: {
        data: {
          type: 'object',
          properties: {
            buyerName: { type: 'string' },
            buyerPublicName: { type: 'string' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            projName: { type: 'string' },
            editBidDetails: {
              type: 'object',
              properties: {
                newAmount: { type: 'number' },
                newPeriod: { type: 'number' },
                oldAmount: { type: 'number' },
                oldPeriod: { type: 'number' },
                bidID: { type: 'number' },
                comment: { type: 'string' },
                id: { type: 'number' },
                requestTime: { type: 'number' },
                responseTime: {
                  anyOf: [
                    { enum: [false], type: 'boolean' },
                    { type: 'number' },
                  ],
                },
                status: {
                  $ref: 'defs.json#/definitions/BidEditRequestStatusApi',
                },
              },
              required: [
                'bidID',
                'comment',
                'id',
                'newAmount',
                'newPeriod',
                'oldAmount',
                'oldPeriod',
                'requestTime',
                'status',
              ],
            },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            linkUrl: { type: 'string' },
          },
          required: [
            'buyerName',
            'buyerPublicName',
            'currencyCode',
            'currencySign',
            'editBidDetails',
            'id',
            'img',
            'linkUrl',
            'projName',
          ],
        },
        type: { type: 'string', enum: ['editAwardedBidDeclined'] },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketEditProjectCollaboratorPermissionsEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['editProjectCollaboratorPermissions'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            projectId: { type: 'number' },
            permissions: {
              type: 'array',
              items: {
                enum: [
                  'bid_award',
                  'chat',
                  'collaborator_add',
                  'dispute_create',
                  'file_upload',
                  'milestone_create',
                  'milestone_release',
                  'milestone_request',
                  'milestone_view',
                  'project_details_edit',
                  'task_list_edit',
                  'tracked_hours_approve',
                  'unknown',
                ],
                type: 'string',
              },
            },
          },
          required: ['id', 'permissions', 'projectId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketEmailChangeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['emailChange'] },
        data: {
          type: 'object',
          properties: {
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
            },
            new_email: { type: 'string' },
            requestId: { type: 'number' },
          },
          required: ['img', 'new_email', 'requestId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketEmailVerifiedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['emailVerified'] },
        data: { type: 'object', properties: {} },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketEscalateDisputeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['escalateDispute'] },
        data: {
          type: 'object',
          properties: {
            dispute_id: { type: 'string' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            time: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'dispute_id',
            'imgUrl',
            'linkUrl',
            'name',
            'publicName',
            'time',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketFailingProjectEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['failingProject'] },
        data: {
          anyOf: [
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                    maxbudget: { type: ['string', 'number'] },
                  },
                  required: ['maxbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: 'string' },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    nonpublic: { type: 'boolean' },
                    projectFreeBid: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    publicName: { type: 'string' },
                    submitDate: { type: 'string' },
                    xpValue: { type: 'number' },
                  },
                  required: [
                    'currencyCode',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'nonpublic',
                    'projIsHourly',
                    'projectFreeBid',
                    'submitDate',
                    'xpValue',
                  ],
                },
              ],
            },
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: { type: ['string', 'number'] },
                    maxbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                  },
                  required: ['minbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: 'string' },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    nonpublic: { type: 'boolean' },
                    projectFreeBid: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    publicName: { type: 'string' },
                    submitDate: { type: 'string' },
                    xpValue: { type: 'number' },
                  },
                  required: [
                    'currencyCode',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'nonpublic',
                    'projIsHourly',
                    'projectFreeBid',
                    'submitDate',
                    'xpValue',
                  ],
                },
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketGenerateAutomaticMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['generateAutomaticMilestone'] },
        data: { $ref: 'defs.json#/definitions/WebsocketMilestone' },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketGiveGetChildPartialMilestoneRelease: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['giveGetChildPartialMilestoneRelease'] },
        data: {
          type: 'object',
          properties: {
            parentId: { type: 'number' },
            childId: { type: 'number' },
            childName: { type: 'string' },
            bonusRequirement: { type: 'number' },
            currencyCode: { type: 'string' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
          },
          required: [
            'bonusRequirement',
            'childId',
            'childName',
            'currencyCode',
            'imgUrl',
            'linkUrl',
            'parentId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketGiveGetChildReceivedSignUpBonusEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['giveGetChildReceivedSignupBonus'] },
        data: {
          type: 'object',
          properties: {
            parentId: { type: 'number' },
            childId: { type: 'number' },
            bonus: { type: 'number' },
            currencyCode: { type: 'string' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
          },
          required: [
            'bonus',
            'childId',
            'currencyCode',
            'imgUrl',
            'linkUrl',
            'parentId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketGiveGetChildSignUpEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['giveGetChildSignUp'] },
        data: {
          type: 'object',
          properties: {
            parentId: { type: 'number' },
            childId: { type: 'number' },
            childName: { type: 'string' },
            bonus: { type: 'number' },
            bonusRequirement: { type: 'number' },
            currencyCode: { type: 'string' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
          },
          required: [
            'bonus',
            'bonusRequirement',
            'childId',
            'childName',
            'currencyCode',
            'imgUrl',
            'linkUrl',
            'parentId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketGiveGetParentBonusEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['giveGetParentBonus'] },
        data: {
          type: 'object',
          properties: {
            parentId: { type: 'number' },
            bonus: { type: 'number' },
            currencyCode: { type: 'string' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
          },
          required: ['bonus', 'currencyCode', 'imgUrl', 'linkUrl', 'parentId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketGroupChatEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['groupchat'] },
        parent_type: { type: 'string', enum: ['notifications'] },
        data: {
          type: 'object',
          properties: {
            action: { enum: ['add', 'remove'], type: 'string' },
            payload: {
              type: 'object',
              properties: {
                members: { type: 'array', items: { type: 'number' } },
                thread: { type: 'number' },
              },
              required: ['members', 'thread'],
            },
          },
          required: ['action', 'payload'],
        },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
        id: { type: 'string' },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketHighLtvAnnualDiscountEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['highLtvAnnualDiscount'] },
        data: {
          type: 'object',
          properties: {
            id: { type: ['string', 'number'] },
            userDisplayName: { type: 'string' },
            linkUrl: { type: 'string' },
          },
          required: ['id', 'linkUrl', 'userDisplayName'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketHireMeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['hireMe'] },
        state: { type: 'string' },
        data: {
          type: 'object',
          properties: {
            acceptByTime: { type: 'number' },
            appended_descr: { type: 'string' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            jobString: { type: 'string' },
            linkUrl: { type: 'string' },
            period: { type: ['string', 'number'] },
            projIsHourly: { type: 'boolean' },
            publicName: { type: 'string' },
            sum: { type: ['string', 'number'] },
            title: { type: 'string' },
            userId: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'appended_descr',
            'currencyCode',
            'currencySign',
            'id',
            'imgUrl',
            'jobString',
            'linkUrl',
            'projIsHourly',
            'sum',
            'title',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketHourlyContractUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['hourlyContractUpdate'] },
        data: {
          type: 'object',
          properties: {
            hourlyContract: {
              $ref:
                'defs.json#/definitions/UndefinedFieldsToNull<HourlyContractApi>',
            },
          },
          required: ['hourlyContract'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    'UndefinedFieldsToNull<HourlyContractApi>': {
      type: 'object',
      properties: {
        id: { type: ['null', 'number'] },
        project_id: { type: ['null', 'number'] },
        bid_id: { type: ['null', 'number'] },
        default_hourly_rate: { type: ['null', 'number'] },
        default_work_limit: { type: ['null', 'number'] },
        billing_cycle: { type: ['null', 'string'] },
        invoice_payment_method: { type: ['null', 'string'] },
        current_hourly_rate: { type: ['null', 'number'] },
        current_work_limit: { type: ['null', 'number'] },
        timezone: {
          anyOf: [
            {
              $ref: 'defs.json#/definitions/UndefinedFieldsToNull<TimezoneApi>',
            },
            { type: 'null' },
          ],
        },
        invalid_time: { type: ['null', 'number'] },
        time_tracking_stopped: { type: ['null', 'number'] },
        invoice_id: { type: ['null', 'number'] },
        project_owner_id: { type: ['null', 'number'] },
        bidder_id: { type: ['null', 'number'] },
        uninvoiced_amount: { type: ['null', 'number'] },
        payments_to_date: { type: ['null', 'number'] },
      },
      required: [
        'bid_id',
        'bidder_id',
        'billing_cycle',
        'current_hourly_rate',
        'current_work_limit',
        'default_hourly_rate',
        'default_work_limit',
        'id',
        'invalid_time',
        'invoice_id',
        'invoice_payment_method',
        'payments_to_date',
        'project_id',
        'project_owner_id',
        'time_tracking_stopped',
        'timezone',
        'uninvoiced_amount',
      ],
    },
    'UndefinedFieldsToNull<TimezoneApi>': {
      type: 'object',
      properties: {
        id: { type: ['null', 'number'] },
        country: { type: ['null', 'string'] },
        timezone: { type: ['null', 'string'] },
        offset: { type: ['null', 'number'] },
      },
      required: ['country', 'id', 'offset', 'timezone'],
    },
    WebsocketInviteToContestEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['inviteToContest'] },
        data: {
          type: 'object',
          properties: {
            buyer: { type: ['string', 'number'] },
            buyerName: { type: 'string' },
            buyerPublicName: { type: 'string' },
            buyerUrl: { type: 'string' },
            contest_recommended_skills: { type: 'string' },
            currencycode: { type: 'string' },
            currencysign: { type: 'string' },
            description: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            prize: { type: ['string', 'number'] },
            sellerId: { type: ['string', 'number'] },
            sellerName: { type: 'string' },
            sellerPublicName: { type: 'string' },
            title: { type: 'string' },
            type: { type: ['null', 'string'] },
          },
          required: [
            'buyer',
            'buyerName',
            'buyerUrl',
            'contest_recommended_skills',
            'currencycode',
            'currencysign',
            'description',
            'id',
            'imgUrl',
            'linkUrl',
            'name',
            'prize',
            'sellerId',
            'sellerName',
            'title',
            'type',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketInviteUserBidEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['inviteUserBid'] },
        data: {
          allOf: [
            { $ref: 'defs.json#/definitions/WebsocketProjectData' },
            {
              type: 'object',
              properties: {
                currencycode: { type: 'string' },
                currencysign: { type: 'string' },
                inviteeId: { type: ['string', 'number'] },
                minBudget: { type: 'number' },
                maxBudget: {
                  anyOf: [
                    { enum: [false], type: 'boolean' },
                    { type: 'number' },
                  ],
                },
                inviteeName: { type: 'string' },
                projIsHourly: { type: 'boolean' },
                publicName: { type: 'string' },
              },
              required: [
                'currencycode',
                'currencysign',
                'inviteeId',
                'inviteeName',
                'projIsHourly',
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketInvoiceFeedbackEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['invoiceFeedback'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: 'string' },
            id: { type: 'string' },
            invoiceId: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            name: { type: 'string' },
            seoUrl: { type: 'string' },
          },
          required: ['accountId', 'id', 'img', 'name', 'seoUrl'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketInvoicePaidEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['invoicePaid'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: 'string' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            id: { type: 'string' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            invoiceId: { type: ['string', 'number'] },
            name: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: 'string' },
            userName: { type: 'string' },
          },
          required: [
            'amount',
            'currencyCode',
            'currencySign',
            'id',
            'img',
            'invoiceId',
            'name',
            'publicName',
            'seoUrl',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketInvoiceRequestedChangeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['invoiceRequestChange'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: ['string', 'number'] },
            bidId: { type: ['string', 'number'] },
            currencyCode: { type: 'string' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            name: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: 'string' },
            userName: { type: 'string' },
          },
          required: [
            'amount',
            'bidId',
            'currencyCode',
            'img',
            'name',
            'seoUrl',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketInvoiceRequestedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['invoiceRequested'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: ['string', 'number'] },
            amount: { type: ['string', 'number'] },
            bidId: { type: ['string', 'number'] },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            dueDate: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            invoiceId: { type: ['string', 'number'] },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            sellerId: { type: ['string', 'number'] },
            seoUrl: { type: 'string' },
            state: { type: 'string' },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
          },
          required: [
            'accountId',
            'amount',
            'bidId',
            'currencyCode',
            'currencySign',
            'dueDate',
            'id',
            'imgUrl',
            'invoiceId',
            'linkUrl',
            'name',
            'sellerId',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketInvoiceSummaryUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['invoiceSummaryUpdate'] },
        data: {
          type: 'object',
          properties: {
            invoiceId: { type: 'number' },
            totalHours: { type: 'number' },
            hoursAmount: { type: 'number' },
            resultAmount: { type: 'number' },
            otherAmount: { type: 'number' },
          },
          required: [
            'hoursAmount',
            'invoiceId',
            'otherAmount',
            'resultAmount',
            'totalHours',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketInvoiceUpdatedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['invoiceUpdated'] },
        data: {
          type: 'object',
          properties: {
            projectId: { type: 'number' },
            bidId: { type: 'number' },
            buyerId: { type: 'number' },
            sellerId: { type: 'number' },
            invoiceId: { type: 'number' },
            status: { $ref: 'defs.json#/definitions/InvoiceStatusApi' },
            isExternal: { type: 'boolean' },
            isAutomatic: { type: 'boolean' },
            currency: { $ref: 'defs.json#/definitions/CurrencyApi' },
            timeRaised: { type: 'number' },
            periodStart: { type: 'number' },
            periodEnd: { type: 'number' },
            milestoneId: { type: ['null', 'number'] },
            totalHours: { type: 'number' },
            totalHoursAmount: { type: 'number' },
            totalResultAmount: { type: 'number' },
            totalOtherAmount: { type: 'number' },
          },
          required: [
            'bidId',
            'buyerId',
            'currency',
            'invoiceId',
            'isAutomatic',
            'isExternal',
            'milestoneId',
            'periodEnd',
            'periodStart',
            'projectId',
            'sellerId',
            'status',
            'timeRaised',
            'totalHours',
            'totalHoursAmount',
            'totalOtherAmount',
            'totalResultAmount',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    InvoiceStatusApi: {
      enum: [
        'disputed',
        'draft',
        'paid',
        'partially_paid',
        'unpaid',
        'withdrawn',
      ],
      type: 'string',
    },
    WebsocketInvoiceWithdrawnEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['invoiceWithdrawn'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: ['string', 'number'] },
            currencyCode: { type: 'string' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            name: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: 'string' },
            userName: { type: 'string' },
          },
          required: [
            'amount',
            'currencyCode',
            'img',
            'name',
            'seoUrl',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketIPAgreementUpgradeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['ipAgreementUpgrade'] },
        data: {
          type: 'object',
          properties: { projectId: { type: 'number' } },
          required: ['projectId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketKYCEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['kyc'] },
        data: {
          type: 'object',
          properties: {
            country: { type: 'string' },
            isCorporate: { type: 'string' },
            status: { $ref: 'defs.json#/definitions/KYCStatus' },
          },
          required: ['status'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    KYCStatus: {
      enum: ['approved', 'declined', 'pending', 'recommended', 'required'],
      type: 'string',
    },
    WebsocketLevelUpEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['levelUp'] },
        data: {
          type: 'object',
          properties: {
            id: { type: ['string', 'number'] },
            level: { type: 'string' },
            membership: { type: 'boolean' },
            perks: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  description: { type: 'string' },
                  item: { type: 'boolean' },
                  magnitude: { type: 'number' },
                  name: { enum: ['BidRefreshRate', 'item'], type: 'string' },
                  symbol: { type: 'string' },
                },
                required: ['description', 'item', 'magnitude', 'symbol'],
              },
            },
            username: { type: 'string' },
            linkUrl: { type: 'string' },
            game: { type: 'string', enum: ['level'] },
          },
          required: [
            'game',
            'id',
            'level',
            'linkUrl',
            'membership',
            'perks',
            'username',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketLocalJobPostedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['localJobPosted'] },
        data: {
          anyOf: [
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                    maxbudget: { type: ['string', 'number'] },
                  },
                  required: ['maxbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: ['null', 'string'] },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    exchangerate: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    isLocal: { type: 'boolean', enum: [true] },
                    nonpublic: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    submitDate: { type: 'string' },
                    publicName: { type: 'string' },
                  },
                  required: [
                    'currencyCode',
                    'exchangerate',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'isLocal',
                    'nonpublic',
                    'projIsHourly',
                    'submitDate',
                  ],
                },
              ],
            },
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: { type: ['string', 'number'] },
                    maxbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                  },
                  required: ['minbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: ['null', 'string'] },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    exchangerate: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    isLocal: { type: 'boolean', enum: [true] },
                    nonpublic: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    submitDate: { type: 'string' },
                    publicName: { type: 'string' },
                  },
                  required: [
                    'currencyCode',
                    'exchangerate',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'isLocal',
                    'nonpublic',
                    'projIsHourly',
                    'submitDate',
                  ],
                },
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketLogoutEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['logout'] },
        data: { type: 'object', properties: {} },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketMakeDisputeOfferEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['makeDisputeOffer'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: ['string', 'number'] },
            currency: {
              type: 'object',
              properties: {
                code: { type: 'string' },
                sign: { type: 'string' },
              },
              required: ['code', 'sign'],
            },
            dispute_id: { type: 'string' },
            id: { type: 'number' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            sender_role: { type: 'string' },
            userName: { type: 'string' },
          },
          required: [
            'amount',
            'currency',
            'dispute_id',
            'id',
            'imgUrl',
            'linkUrl',
            'name',
            'publicName',
            'sender_role',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketMilestoneStatusUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['milestoneStatusUpdate'] },
        data: {
          type: 'object',
          properties: {
            sellerId: { type: 'number' },
            buyerId: { type: 'number' },
            projectId: { type: 'number' },
            bidId: { type: ['null', 'number'] },
            milestoneId: { type: 'number' },
            milestoneStatus: {
              $ref: 'defs.json#/definitions/MilestoneStatusApi',
            },
          },
          required: [
            'bidId',
            'buyerId',
            'milestoneId',
            'milestoneStatus',
            'projectId',
            'sellerId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    MilestoneStatusApi: {
      enum: [
        'canceled',
        'cleared',
        'disputed',
        'frozen',
        'pending',
        'pending_clearance',
        'pending_recipient_kyc',
        'requested_release',
        'unknown',
      ],
      type: 'string',
    },
    WebsocketNDASignedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['ndaSigned'] },
        data: {
          type: 'object',
          properties: {
            projectId: { type: 'number' },
            time: { type: 'number' },
            userId: { type: 'number' },
          },
          required: ['projectId', 'time', 'userId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketNDAUpgradeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['ndaUpgrade'] },
        data: {
          type: 'object',
          properties: { projectId: { type: 'number' } },
          required: ['projectId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketNewDisputeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['newDispute'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: 'number' },
            dispute_id: { type: 'number' },
            id: { type: 'number' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            reason: { type: 'string' },
            time: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'accountId',
            'dispute_id',
            'id',
            'linkUrl',
            'name',
            'publicName',
            'time',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketNotifyFollowerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['notifyfollower'] },
        data: { $ref: 'defs.json#/definitions/WebsocketProjectData' },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketNPSSubmittedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['npsSubmitted'] },
        data: {
          type: 'object',
          properties: {
            netPromoterScore: {
              $ref: 'defs.json#/definitions/NetPromoterScoreApi',
            },
          },
          required: ['netPromoterScore'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    NetPromoterScoreApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        from_user_id: { type: 'number' },
        to_user_id: { type: 'number' },
        type: {
          enum: [
            'contest_platform',
            'employer',
            'freelancer',
            'sitewide_experience',
            'support_platform',
            'support_queue',
            'verification_experience',
          ],
          type: 'string',
        },
        score: { type: 'number' },
        comment: { type: 'string' },
        source: {
          enum: [
            'contest_handover',
            'contest_ongoing',
            'helpcenter_experience',
            'invoice',
            'kyc_complete',
            'milestone',
            'project_complete',
            'rich_message_on_24hr',
            'rich_message_on_resolve',
            'sitewide_experience_complete',
            'sitewide_experience_pending',
          ],
          type: 'string',
        },
        source_id: { type: 'number' },
        timestamp: { type: 'number' },
        to_entity_id: { type: 'number' },
      },
    },
    WebsocketPendingFundsEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['pendingFunds'] },
        data: {
          type: 'object',
          properties: {
            amount: { type: 'string' },
            currencycode: { type: 'string' },
            currencysign: { type: 'string' },
            descr: { type: 'string' },
            message: { type: 'string' },
            reason: { type: 'string' },
          },
          required: [
            'amount',
            'currencycode',
            'currencysign',
            'descr',
            'message',
            'reason',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketPostDraftProjectEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['postDraftProject'] },
        data: {
          type: 'object',
          properties: {
            projectId: { type: 'number' },
            projectName: { type: 'string' },
          },
          required: ['projectId', 'projectName'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketPrizeDispersedEmployerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['prizeDispersedEmployer'] },
        data: {
          type: 'object',
          properties: {
            contest_name: { type: 'string' },
            contest_url: { type: 'string' },
            freelancer_publicname: { type: 'string' },
            freelancer_username: { type: 'string' },
            hasWinner: { type: 'boolean' },
          },
          required: ['contest_name', 'contest_url', 'hasWinner'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketPrizeDispersedFreelancerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['prizeDispersedFreelancer'] },
        data: {
          type: 'object',
          properties: {
            contest_name: { type: 'string' },
            contest_url: { type: 'string' },
          },
          required: ['contest_name', 'contest_url'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectCompletedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['completed'] },
        state: { type: 'string' },
        data: {
          type: 'object',
          properties: {
            amount: { type: ['string', 'number'] },
            categoryName: { type: 'string' },
            completeStatus: { type: 'string' },
            currencycode: { type: 'string' },
            currencyid: { type: ['string', 'number'] },
            currencysign: { type: 'string' },
            employerId: { type: ['string', 'number'] },
            employerPublicName: { type: 'string' },
            employerUsername: { type: 'string' },
            expiredTimestamp: { type: ['null', 'string'] },
            freelancerId: { type: ['string', 'number'] },
            freelancerPublicName: { type: 'string' },
            freelancerUsername: { type: 'string' },
            id: { type: ['string', 'number'] },
            img_e: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            img_f: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            name: { type: 'string' },
            selectionId: { type: ['string', 'number'] },
            seoUrl: { type: ['null', 'string', 'number'] },
            state: { type: 'string' },
            submitDate: { type: 'string' },
            bidId: { type: ['null', 'string', 'number'] },
          },
          required: [
            'amount',
            'categoryName',
            'completeStatus',
            'currencycode',
            'currencyid',
            'currencysign',
            'employerId',
            'employerUsername',
            'expiredTimestamp',
            'freelancerId',
            'freelancerUsername',
            'id',
            'img_e',
            'img_f',
            'name',
            'selectionId',
            'seoUrl',
            'submitDate',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectEmailVerificationRequiredEvent: {
      type: 'object',
      properties: {
        type: {
          type: 'string',
          enum: ['projectEmailVerificationRequiredEvent'],
        },
        data: {
          type: 'object',
          properties: {
            userId: { type: 'number' },
            projectId: { type: 'number' },
          },
          required: ['userId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['project'] },
        data: {
          anyOf: [
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                    maxbudget: { type: ['string', 'number'] },
                  },
                  required: ['maxbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: 'string' },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    isLocal: { type: 'boolean' },
                    nonpublic: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    submitDate: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: 'string' },
                      ],
                    },
                    publicName: { type: 'string' },
                  },
                  required: [
                    'currencyCode',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'isLocal',
                    'nonpublic',
                    'projIsHourly',
                    'submitDate',
                  ],
                },
              ],
            },
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: { type: ['string', 'number'] },
                    maxbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                  },
                  required: ['minbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: 'string' },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    isLocal: { type: 'boolean' },
                    nonpublic: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    submitDate: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: 'string' },
                      ],
                    },
                    publicName: { type: 'string' },
                  },
                  required: [
                    'currencyCode',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'isLocal',
                    'nonpublic',
                    'projIsHourly',
                    'submitDate',
                  ],
                },
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectHireMeExpiredEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['projectHireMeExpired'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            userName: { type: 'string' },
            autoRepostProjectId: { type: 'number' },
            autoRepostProjectName: { type: 'string' },
            jobsURL: { type: 'string' },
            seoUrl: { type: 'string' },
            userId: { type: 'number' },
          },
          required: [
            'id',
            'img',
            'jobsURL',
            'linkUrl',
            'name',
            'publicName',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectInviteToBid: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['projectInviteToBid'] },
        data: {
          type: 'object',
          properties: {
            projectId: { type: 'number' },
            freelancerId: { type: 'number' },
          },
          required: ['freelancerId', 'projectId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectSharedWithYouEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['projectSharedWithYou'] },
        data: {
          type: 'object',
          properties: {
            actingInviterPublicName: { type: ['null', 'string'] },
            actingInviterUsername: { type: ['null', 'string'] },
            employerPublicName: { type: 'string' },
            employerUsername: { type: 'string' },
            projectId: { type: 'number' },
            projectName: { type: 'string' },
          },
          required: [
            'employerPublicName',
            'employerUsername',
            'projectId',
            'projectName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketProjectStatusChangeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['projectStatusChange'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            newStatus: {
              type: 'object',
              properties: {
                formattedState: {
                  type: 'object',
                  properties: {
                    desc: { type: 'string' },
                    name: { type: 'string' },
                  },
                  required: ['desc', 'name'],
                },
                info: {
                  type: 'object',
                  properties: {
                    opened: { type: 'boolean' },
                    closed: { type: 'boolean' },
                    closed_cancelled: { type: 'boolean' },
                    closed_expired: { type: 'boolean' },
                    closed_accepted: { type: 'boolean' },
                    frozen: { type: 'boolean' },
                    frozen_bidtimeout: { type: 'boolean' },
                    frozen_waiting: { type: 'boolean' },
                    pending: { type: 'boolean' },
                    rejected: { type: 'boolean' },
                  },
                  required: [
                    'closed',
                    'frozen',
                    'opened',
                    'pending',
                    'rejected',
                  ],
                },
                state: { enum: ['A', 'C', 'D', 'F', 'P', 'R'], type: 'string' },
                status: { $ref: 'defs.json#/definitions/ProjectStatusApi' },
                subStatus: {
                  anyOf: [
                    {
                      enum: [
                        'cancel_admin',
                        'cancel_buyer',
                        'cancel_seller',
                        'closed_awarded',
                        'closed_expired',
                        false,
                        'frozen_awarded',
                        'frozen_timeout',
                        'requires_correction',
                      ],
                    },
                    { type: 'null' },
                  ],
                },
              },
              required: [
                'formattedState',
                'info',
                'state',
                'status',
                'subStatus',
              ],
            },
          },
          required: ['id', 'newStatus'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketQuickHireProjectEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['quickHireProject'] },
        data: {
          allOf: [
            { $ref: 'defs.json#/definitions/WebsocketProjectData' },
            {
              type: 'object',
              properties: {
                bidderId: { type: ['string', 'number'] },
                bidderName: { type: 'string' },
                currency: {
                  type: 'object',
                  properties: {
                    code: { type: 'string' },
                    sign: { type: 'string' },
                  },
                  required: ['code', 'sign'],
                },
                period: { type: ['string', 'number'] },
                projIsHourly: { type: 'boolean' },
                publicName: { type: 'string' },
                submitDate: { type: 'string' },
                sum: { type: ['string', 'number'] },
              },
              required: [
                'bidderId',
                'bidderName',
                'projIsHourly',
                'submitDate',
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRecruiterProjectEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['recruiterProject'] },
        data: {
          anyOf: [
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                    maxbudget: { type: ['string', 'number'] },
                  },
                  required: ['maxbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: 'string' },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    exchangerate: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    isLocal: { type: 'boolean' },
                    nonpublic: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    submitDate: { type: 'string' },
                    publicName: { type: 'string' },
                  },
                  required: [
                    'currencyCode',
                    'exchangerate',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'isLocal',
                    'nonpublic',
                    'projIsHourly',
                    'submitDate',
                  ],
                },
              ],
            },
            {
              allOf: [
                { $ref: 'defs.json#/definitions/WebsocketProjectData' },
                {
                  type: 'object',
                  properties: {
                    minbudget: { type: ['string', 'number'] },
                    maxbudget: {
                      anyOf: [
                        { enum: [false], type: 'boolean' },
                        { type: ['null', 'string', 'number'] },
                      ],
                    },
                  },
                  required: ['minbudget'],
                },
                {
                  type: 'object',
                  properties: {
                    address: { type: 'string' },
                    currency: { type: 'string' },
                    currencyCode: { type: 'string' },
                    exchangerate: { type: 'string' },
                    featured: { type: 'boolean' },
                    free_bid_until: { type: 'number' },
                    fulltime: { type: 'boolean' },
                    hideBids: { type: 'boolean' },
                    isLocal: { type: 'boolean' },
                    nonpublic: { type: 'boolean' },
                    projIsHourly: { type: 'boolean' },
                    submitDate: { type: 'string' },
                    publicName: { type: 'string' },
                  },
                  required: [
                    'currencyCode',
                    'exchangerate',
                    'featured',
                    'fulltime',
                    'hideBids',
                    'isLocal',
                    'nonpublic',
                    'projIsHourly',
                    'submitDate',
                  ],
                },
              ],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRejectedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['rejected'] },
        data: {
          type: 'object',
          properties: {
            addtionalMsg: { type: 'string' },
            id: { type: 'number' },
            name: { type: 'string' },
            rejectReasonConfig: {
              type: 'array',
              items: {
                type: 'object',
                properties: { descr: { type: 'string' } },
              },
            },
            img: {
              type: 'object',
              properties: { logo_url: { type: ['string', 'boolean'] } },
            },
          },
          required: ['id', 'name'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRejectMilestoneCancellationEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['rejectMilestoneCancellation'] },
        data: {
          type: 'object',
          properties: { id: { type: 'number' } },
          required: ['id'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketReleaseMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['releaseMilestone'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: ['string', 'number'] },
            amount: { type: ['string', 'number'] },
            currencycode: { type: 'string' },
            currencysign: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            otherReason: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            submitDate: { type: 'string' },
            title: { type: 'string' },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
            milestoneId: { type: ['string', 'number'] },
          },
          required: [
            'accountId',
            'amount',
            'currencycode',
            'currencysign',
            'id',
            'imgUrl',
            'linkUrl',
            'milestoneId',
            'name',
            'otherReason',
            'seoUrl',
            'submitDate',
            'title',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketReleasePartMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['releasePartMilestone'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: 'number' },
            amount: { type: 'string' },
            bidId: { type: 'number' },
            currencycode: { type: 'string' },
            currencysign: { type: 'string' },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
            },
            leftAmount: { type: 'number' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            otherReason: { type: 'string' },
            publicName: { type: 'string' },
            tranId: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'accountId',
            'amount',
            'bidId',
            'currencycode',
            'currencysign',
            'id',
            'img',
            'leftAmount',
            'linkUrl',
            'name',
            'otherReason',
            'publicName',
            'tranId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRemindUseBidsEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['remindUseBids'] },
        data: {
          type: 'object',
          properties: {
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            username: { type: 'string' },
            bids_remaining: { type: 'string' },
          },
          required: ['bids_remaining', 'img', 'username'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRequestCancelMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['requestCancelMilestone'] },
        data: {
          type: 'object',
          properties: {
            milestoneId: { type: 'number' },
            actionReason: {
              $ref: 'defs.json#/definitions/MilestoneCancelRequestReasonApi',
            },
            actionReasonText: { type: 'string' },
          },
          required: ['actionReason', 'actionReasonText', 'milestoneId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    MilestoneCancelRequestReasonApi: {
      enum: [
        'accidentally_created',
        'freelancer_did_not_complete_task',
        'freelancer_did_not_meet_deadline',
        'no_longer_needed',
        'other',
      ],
      type: 'string',
    },
    WebsocketRequestEndProjectEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['requestEndProject'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: ['string', 'number'] },
            bidId: { type: ['string', 'number'] },
            categoryName: { type: 'string' },
            dayCount: { type: ['string', 'number'] },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            submitDate: { type: 'string' },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
          },
          required: [
            'accountId',
            'bidId',
            'categoryName',
            'dayCount',
            'id',
            'imgUrl',
            'linkUrl',
            'name',
            'seoUrl',
            'submitDate',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRequestMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['requestMilestone'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: ['string', 'number'] },
            amount: { type: ['string', 'number'] },
            bidId: { type: ['string', 'number'] },
            currencyCode: { type: 'string' },
            currencyId: { type: ['string', 'number'] },
            currencySign: { type: 'string' },
            description: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            requestId: { type: ['string', 'number'] },
            sellerId: { type: ['string', 'number'] },
            seoUrl: { type: ['null', 'string', 'number'] },
            state: { type: 'string' },
            submitDate: { type: 'string' },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
          },
          required: [
            'accountId',
            'amount',
            'bidId',
            'currencyCode',
            'currencyId',
            'currencySign',
            'description',
            'id',
            'imgUrl',
            'linkUrl',
            'name',
            'requestId',
            'sellerId',
            'seoUrl',
            'submitDate',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRequestToReleaseEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['requestToRelease'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: ['string', 'number'] },
            amount: { type: ['string', 'number'] },
            bidId: { type: ['string', 'number'] },
            currencycode: { type: 'string' },
            currencysign: { type: 'string' },
            descr: { type: 'string' },
            id: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            state: { type: 'string' },
            tranId: { type: ['string', 'number'] },
            userId: { type: ['string', 'number'] },
            userName: { type: 'string' },
          },
          required: [
            'accountId',
            'amount',
            'bidId',
            'currencycode',
            'currencysign',
            'descr',
            'id',
            'imgUrl',
            'linkUrl',
            'name',
            'seoUrl',
            'tranId',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketReviewActivateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['reviewActivate'] },
        data: {
          type: 'object',
          properties: {
            currencyId: { type: ['string', 'number'] },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            isAutomaticPayments: { type: 'boolean' },
            isHourly: { type: 'boolean' },
            isMilestoneCreated: { type: 'boolean' },
            isQHP: { type: ['null', 'boolean'] },
            name: { type: 'string' },
            notShowEmployerFee: { type: ['null', 'boolean'] },
            projectCreateType: {
              anyOf: [
                { enum: ['inline-rehire', 'normal'], type: 'string' },
                { type: 'null' },
              ],
            },
            quickhireFreelancerId: { type: ['null', 'string', 'number'] },
            quickhireFreelancerPublicName: { type: ['null', 'string'] },
            quickhireFreelancerUsername: { type: ['null', 'string'] },
            seoUrl: { type: ['null', 'string', 'number'] },
          },
          required: [
            'currencyId',
            'id',
            'img',
            'isAutomaticPayments',
            'isHourly',
            'isMilestoneCreated',
            'isQHP',
            'name',
            'notShowEmployerFee',
            'projectCreateType',
            'quickhireFreelancerId',
            'quickhireFreelancerPublicName',
            'quickhireFreelancerUsername',
            'seoUrl',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketReviewPostedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['reviewpostednew'] },
        state: { type: 'string' },
        data: {
          type: 'object',
          properties: {
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            id: { type: 'number' },
            invoice_id: { type: 'number' },
            name: { type: 'string' },
            projIsHourly: { type: 'boolean' },
            publicName: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            userId: { type: 'number' },
            userName: { type: 'string' },
          },
          required: [
            'id',
            'img',
            'name',
            'projIsHourly',
            'publicName',
            'seoUrl',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRevokedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['revoked'] },
        data: {
          type: 'object',
          properties: {
            apiMessage: {
              type: 'object',
              properties: {
                project: {
                  type: 'object',
                  properties: {
                    id: { type: 'number' },
                    owner_id: { type: 'number' },
                    title: { type: 'string' },
                    seo_url: { type: 'string' },
                    hireme: { type: 'boolean' },
                  },
                  required: ['hireme', 'id', 'owner_id', 'seo_url', 'title'],
                },
                bid: {
                  type: 'object',
                  properties: {
                    id: { type: 'number' },
                    bidder_id: { type: 'number' },
                    award_status: {
                      $ref: 'defs.json#/definitions/BidAwardStatusApi',
                    },
                  },
                  required: ['award_status', 'bidder_id', 'id'],
                },
              },
              required: ['bid', 'project'],
            },
            awardeeId: { type: 'number' },
            bidId: { type: ['string', 'number'] },
            imgUrl: { type: 'string' },
            projectId: { type: 'number' },
          },
          required: ['apiMessage', 'awardeeId', 'bidId', 'imgUrl', 'projectId'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketRevokeProjectCollaboratorPermissionsEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['revokeProjectCollaborator'] },
        data: {
          type: 'object',
          properties: { id: { type: 'number' } },
          required: ['id'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketSendDisputeMessageEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['sendDisputeMessage'] },
        data: {
          type: 'object',
          properties: {
            dispute_id: { type: 'string' },
            id: { type: 'number' },
            imgUrl: { type: 'string' },
            linkUrl: { type: 'string' },
            message: { type: 'string' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            userName: { type: 'string' },
            userId: { type: 'string' },
          },
          required: [
            'dispute_id',
            'id',
            'imgUrl',
            'linkUrl',
            'message',
            'name',
            'publicName',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketServiceApprovedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['serviceApproved'] },
        data: { $ref: 'defs.json#/definitions/WebsocketServiceData' },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketServiceData: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        service_id: { type: ['string', 'number'] },
        service_name: { type: 'string' },
        service_url: { type: 'string' },
        service_duration: { type: 'string' },
        service_cost: { type: ['string', 'number'] },
        currency_sign: { type: 'string' },
        currency_code: { type: 'string' },
        service_img: { type: 'string' },
      },
      required: [
        'currency_code',
        'currency_sign',
        'id',
        'service_cost',
        'service_duration',
        'service_id',
        'service_img',
        'service_name',
        'service_url',
      ],
    },
    WebsocketServiceProjectEndingSellerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['serviceProjectEndingSeller'] },
        data: {
          type: 'object',
          properties: {
            bid_id: { type: ['string', 'number'] },
            buyer_id: { type: ['string', 'number'] },
            buyer_name: { type: 'string' },
            hours_remaining: { type: 'number' },
            id: { type: ['string', 'number'] },
            order_start_date: { type: 'string' },
            project_id: { type: ['string', 'number'] },
            project_name: { type: 'string' },
            project_url: { type: 'string' },
            seller_id: { type: ['string', 'number'] },
            seller_name: { type: 'string' },
            service_id: { type: ['string', 'number'] },
            service_name: { type: 'string' },
          },
          required: [
            'bid_id',
            'buyer_id',
            'buyer_name',
            'hours_remaining',
            'id',
            'order_start_date',
            'project_id',
            'project_name',
            'project_url',
            'seller_id',
            'seller_name',
            'service_id',
            'service_name',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketServiceProjectPostedSellerEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['serviceProjectPostedSeller'] },
        data: {
          type: 'object',
          properties: {
            bid_id: { type: ['string', 'number'] },
            buyer_id: { type: ['string', 'number'] },
            buyer_img_url: { type: 'string' },
            buyer_name: { type: 'string' },
            buyer_public_name: { type: 'string' },
            currency_code: { type: 'string' },
            currency_sign: { type: 'string' },
            order_end_date: { type: 'string' },
            order_start_date: { type: 'string' },
            project_cost: { type: ['string', 'number'] },
            project_id: { type: ['string', 'number'] },
            project_name: { type: 'string' },
            project_url: { type: 'string' },
            seller_id: { type: ['string', 'number'] },
            seller_img_url: { type: 'string' },
            seller_name: { type: 'string' },
            seller_public_name: { type: 'string' },
            service_id: { type: ['string', 'number'] },
            service_name: { type: 'string' },
            service_url: { type: 'string' },
          },
          required: [
            'bid_id',
            'buyer_id',
            'buyer_img_url',
            'buyer_name',
            'currency_code',
            'currency_sign',
            'order_end_date',
            'order_start_date',
            'project_cost',
            'project_id',
            'project_name',
            'project_url',
            'seller_id',
            'seller_img_url',
            'seller_name',
            'seller_public_name',
            'service_id',
            'service_name',
            'service_url',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketServiceRejectedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['serviceRejected'] },
        data: { $ref: 'defs.json#/definitions/WebsocketServiceData' },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketServiceStatusChangedEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['serviceStatusChanged'] },
        data: {
          type: 'object',
          properties: { id: { type: ['string', 'number'] } },
          required: ['id'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketShowcaseSourceApprovalEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['showcaseSourceApproval'] },
        parent_type: { type: 'string', enum: ['notifications'] },
        data: {
          type: 'object',
          properties: {
            linkUrl: { type: 'string' },
            projectId: { type: 'number' },
            projectTitle: { type: 'string' },
            projectType: {
              $ref: 'defs.json#/definitions/ShowcaseSourceTypeApi',
            },
          },
          required: ['linkUrl', 'projectId', 'projectTitle', 'projectType'],
        },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
        id: { type: 'string' },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    ShowcaseSourceTypeApi: {
      enum: ['contest', 'external', 'portfolio', 'project'],
      type: 'string',
    },
    WebsocketSignUpFreeTrialUpsellEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['signUpFreeTrialUpsell'] },
        data: {
          type: 'object',
          properties: {
            id: { type: ['string', 'number'] },
            linkUrl: { type: 'string' },
            trialPackageName: { type: 'string' },
          },
          required: ['id', 'linkUrl', 'trialPackageName'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketSponsorBidEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['sponsor_bid'] },
        data: {
          type: 'object',
          properties: {
            id: { type: ['string', 'number'] },
            object: {
              type: 'object',
              properties: {
                bid: {
                  type: 'object',
                  properties: {
                    id: { type: ['string', 'number'] },
                    sum: { type: ['string', 'number'] },
                    users_id: { type: 'number' },
                  },
                  required: ['id', 'sum', 'users_id'],
                },
              },
              required: ['bid'],
            },
          },
          required: ['id', 'object'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketSuggestionForFreelancerAfterReceiveReviewEvent: {
      type: 'object',
      properties: {
        type: {
          type: 'string',
          enum: ['suggestionForFreelancerAfterReceiveReview'],
        },
        data: {
          type: 'object',
          properties: {
            projectId: { type: 'number' },
            projectName: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
            },
            userName: { type: 'string' },
          },
          required: ['img', 'projectId', 'projectName', 'seoUrl', 'userName'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketSupportAgentEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['supportAgent'] },
        data: {
          type: 'object',
          properties: {
            type: {
              enum: ['available', 'away', 'unavailable'],
              type: 'string',
            },
            agent: { $ref: 'defs.json#/definitions/AgentApi' },
          },
          required: ['agent', 'type'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    AgentApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        user_id: { type: 'number' },
        owner: { $ref: 'defs.json#/definitions/AgentOwnerApi' },
        support_type: { $ref: 'defs.json#/definitions/SupportTypeApi' },
        create_time: { type: 'number' },
        state: { $ref: 'defs.json#/definitions/AgentStateApi' },
      },
      required: ['create_time', 'id', 'state', 'support_type', 'user_id'],
    },
    AgentOwnerApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        username: { type: 'string' },
        owner_type: { $ref: 'defs.json#/definitions/AgentOwnerTypeApi' },
      },
      required: ['id', 'owner_type', 'username'],
    },
    AgentOwnerTypeApi: {
      enum: ['arrow_super_user', 'freelancer_admin'],
      type: 'string',
    },
    AgentStateApi: {
      enum: ['available', 'away', 'disabled', 'unavailable'],
      type: 'string',
    },
    WebsocketSupportAgentSessionEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['supportAgentSession'] },
        data: {
          type: 'object',
          properties: {
            type: {
              enum: ['assigned', 'created', 'resolved', 'starred'],
              type: 'string',
            },
            agentSession: { $ref: 'defs.json#/definitions/AgentSessionApi_1' },
            session: { $ref: 'defs.json#/definitions/SessionApi' },
            agent: { $ref: 'defs.json#/definitions/AgentApi' },
          },
          required: ['agentSession', 'session', 'type'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    AgentSessionApi_1: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        session_id: { type: 'number' },
        support_type: { $ref: 'defs.json#/definitions/SupportTypeApi' },
        state: { $ref: 'defs.json#/definitions/AgentSessionStateApi' },
        is_latest: { type: 'boolean' },
        create_time: { type: 'number' },
        resolved_time: { type: 'number' },
        resolved_reason: { $ref: 'defs.json#/definitions/ResolvedReasonApi' },
        agent_id: { type: 'number' },
        is_starred: { type: 'boolean' },
      },
      required: [
        'create_time',
        'id',
        'is_latest',
        'session_id',
        'state',
        'support_type',
      ],
    },
    AgentSessionStateApi: {
      enum: ['assigned', 'resolved', 'unassigned'],
      type: 'string',
    },
    ResolvedReasonApi: {
      type: 'object',
      properties: { description: { type: 'string' } },
    },
    WebsocketSupportQueueEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['supportQueueEvent'] },
        data: {},
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketTaskCreateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['tasklistCreateV1'] },
        data: {
          allOf: [
            { $ref: 'defs.json#/definitions/TaskApi' },
            {
              type: 'object',
              properties: {
                linkUrl: { type: 'string' },
                imgUrl: { type: 'string' },
              },
              required: ['imgUrl', 'linkUrl'],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    TaskApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        owner_id: { type: 'number' },
        create_time: { type: 'number' },
        source: { $ref: 'defs.json#/definitions/TaskSourceApi' },
        status: { $ref: 'defs.json#/definitions/TaskStatusApi' },
        task_list: { type: 'string', enum: ['default_list'] },
        assignee_id: { type: 'number' },
        due_date: { type: 'number' },
        title: { type: 'string' },
        description: { type: 'string' },
      },
      required: [
        'create_time',
        'id',
        'owner_id',
        'source',
        'status',
        'task_list',
      ],
    },
    TaskSourceApi: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        type: { type: 'string', enum: ['project'] },
      },
      required: ['id', 'type'],
    },
    TaskStatusApi: {
      enum: ['closed_deleted', 'closed_resolved', 'in_progress'],
      type: 'string',
    },
    WebsocketTaskUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['tasklistUpdateV1'] },
        data: { $ref: 'defs.json#/definitions/TaskApi' },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketTimeTrackingSessionCreateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['timeTrackingSessionCreate'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            time_started: { type: 'number' },
            invoice_id: { type: 'number' },
            time_last_updated: { type: 'number' },
            manually_tracked: { type: 'boolean' },
            user_id: { type: 'number' },
            project_id: { type: 'number' },
            trackee_id: { type: 'number' },
            bid_id: { type: 'number' },
            note: { type: 'string' },
            invoiceable_time: { type: 'number' },
          },
          required: [
            'bid_id',
            'id',
            'invoiceable_time',
            'manually_tracked',
            'project_id',
            'time_last_updated',
            'time_started',
            'user_id',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketTimeTrackingSessionDeleteEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['timeTrackingSessionDelete'] },
        data: {
          type: 'object',
          properties: { id: { type: 'number' } },
          required: ['id'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketTrackUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['trackUpdate'] },
        data: { $ref: 'defs.json#/definitions/WebsocketTrackPoint' },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketTrackPoint: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        trackId: { type: 'number' },
        latitude: { type: 'number' },
        longitude: { type: 'number' },
        timeCreated: { type: 'number' },
      },
      required: ['id', 'latitude', 'longitude', 'timeCreated', 'trackId'],
    },
    WebsocketTrackCreateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['trackCreate'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            userId: { type: 'number' },
            projectId: { type: 'number' },
            timeStarted: { type: 'number' },
            timeFinished: { type: 'number' },
            duration: { type: 'number' },
            invoiceId: { type: 'number' },
            trackPoints: {
              type: 'array',
              items: { $ref: 'defs.json#/definitions/WebsocketTrackPoint' },
            },
          },
          required: [
            'duration',
            'id',
            'invoiceId',
            'projectId',
            'timeFinished',
            'timeStarted',
            'trackPoints',
            'userId',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketUnknownNotificationsEvent: {
      description:
        "Events that are unknown, or have yet to be defined.\n\nBasically everything in `event_notify.php` that doesn't have a\ncorresponding type in this file ends up here.",
      type: 'object',
      properties: {
        type: {
          enum: [
            'aborted',
            'adminWarningUserBidRestriction',
            'banUserFromBidding',
            'bidsRunningOut',
            'buyFreeMarketService',
            'collaboratorAddedViaChat',
            'collaboratorsUpdatedRefreshChat',
            'communityPromoNoti',
            'contactsAutoAddedReceiver',
            'contactsAutoAddedSender',
            'contestCompleteSellEntryUpsell',
            'contestLockedEmployer',
            'contestLockedFreelancer',
            'contestUpsellFeaturedUpgrade',
            'counterOffer',
            'deleteFile',
            'downgradeToFreeMembershipNoti',
            'draftContestRealtime',
            'employerWelcome',
            'examPassedUpsell',
            'examRetakingDiscount',
            'expertsPromoNoti',
            'firstEarning',
            'freeMarketServiceExpired',
            'freeMarketServiceIsExpired',
            'generic',
            'hostingRequest',
            'hostingShare',
            'inviteFriends',
            'invoiceAcceptedPartial',
            'invoicePartialPaid',
            'localJobsActivation',
            'negotiatedProjectStatusChange',
            'pmb',
            'pmb_public',
            'prehireProjectCreated',
            'projectStatusChange',
            'promoteContest',
            'removeUserFromDirectory',
            'reviewPending',
            'reviewposted',
            'secondBidPlusTrialUpsell',
            'sellFreeMarketService',
            'serviceLimitReached',
            'serviceProjectEndedBuyer',
            'serviceProjectEndedSeller',
            'serviceProjectPostedBuyer',
            'serviceSellerPromotion',
            'serviceSubmitted',
            'showcasePromoNoti',
            'sitesBidCreated',
            'specialLoyaltyDiscount',
            'supportGetHelpNewsfeed',
            'tombstoneNoti',
            'tombstoneNotiEmployer',
            'tombstoneNotiFreelancer',
            'upsellAssistedUpgrade',
            'upsellFeatureUpgrade',
            'upsellIntro',
            'userSideAction',
            'userSideActionFeedback',
            'yahooMailAlert',
          ],
          type: 'string',
        },
        data: {},
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketUpdateMilestoneEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['updateMilestone'] },
        data: {
          type: 'object',
          properties: {
            accountId: { type: 'number' },
            amount: { type: 'number' },
            bidId: { type: 'number' },
            currencyCode: { type: 'string' },
            currencySign: { type: 'string' },
            description: { type: 'string' },
            id: { type: 'number' },
            img: {
              type: 'object',
              properties: { logo_url: { type: ['string', 'boolean'] } },
            },
            isSelected: { type: 'boolean' },
            name: { type: 'string' },
            old_amount: { type: 'number' },
            publicName: { type: 'string' },
            requestId: { type: 'number' },
            sellerId: { type: 'string' },
            seoUrl: { type: ['null', 'string', 'number'] },
            userName: { type: 'string' },
          },
          required: [
            'accountId',
            'amount',
            'bidId',
            'currencyCode',
            'currencySign',
            'description',
            'id',
            'isSelected',
            'name',
            'old_amount',
            'publicName',
            'requestId',
            'sellerId',
            'seoUrl',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketUpgradeToNonFreeMembershipEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['upgradeToNonFreeMembership'] },
        data: {
          type: 'object',
          properties: {
            currencyCode: { type: 'string' },
            currentPlan: { type: ['null', 'string'] },
            freeTrial: { type: ['null', 'boolean'] },
            newPlan: { type: 'string' },
            price: { type: ['null', 'string', 'number'] },
            refundedAmount: { type: ['null', 'number'] },
            start: { type: ['null', 'string'] },
            end: { type: ['null', 'string'] },
            tax: { type: ['null', 'string'] },
            timeUnit: { type: ['null', 'string'] },
            type: { type: 'string' },
          },
          required: [
            'currencyCode',
            'currentPlan',
            'end',
            'freeTrial',
            'newPlan',
            'price',
            'refundedAmount',
            'start',
            'tax',
            'timeUnit',
            'type',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketUploadFileEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['uploadFile'] },
        data: {
          type: 'object',
          properties: {
            file: {
              type: 'object',
              properties: {
                id: { type: ['string', 'number'] },
                name: { type: 'string' },
                size: { type: 'string' },
                isDriveFile: { type: 'boolean' },
              },
              required: ['id', 'name', 'size'],
            },
            id: { type: 'string' },
            img: {
              type: 'object',
              properties: { logo_url: { type: ['string', 'boolean'] } },
            },
            projectId: { type: 'number' },
            name: { type: 'string' },
            publicName: { type: 'string' },
            userName: { type: 'string' },
            userId: { type: 'number' },
            seoUrl: { type: ['null', 'string', 'number'] },
            time: { type: 'number' },
          },
          required: [
            'file',
            'id',
            'name',
            'projectId',
            'publicName',
            'seoUrl',
            'time',
            'userId',
            'userName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketUpsellCrowdsourceFindingEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['upsellCrowdsourceFinding'] },
        data: {
          type: 'object',
          properties: {
            id: { type: ['string', 'number'] },
            project_name: { type: 'string' },
          },
          required: ['id', 'project_name'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketUpsellPlusTrialEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['upsellPlusTrial'] },
        data: {
          type: 'object',
          properties: {
            currency_code: { type: 'string' },
            currency_sign: { type: 'string' },
            extendPrice: { type: 'string' },
            img: {
              type: 'object',
              properties: { profile_logo_url: { type: 'string' } },
              required: ['profile_logo_url'],
            },
            isBoth: { type: 'boolean' },
            isEmployer: { type: 'boolean' },
            isFreelancer: { type: 'boolean' },
            price: { type: 'number' },
            taxName: { type: 'string' },
            trialBenefits: {
              type: 'object',
              properties: {
                bids_limit: {
                  $ref: 'defs.json#/definitions/WebsocketMembershipBenefit',
                },
                offsite_invoice: {
                  $ref: 'defs.json#/definitions/WebsocketMembershipBenefit',
                },
                skills_limit: {
                  $ref: 'defs.json#/definitions/WebsocketMembershipBenefit',
                },
              },
              required: ['bids_limit', 'offsite_invoice', 'skills_limit'],
            },
            trialPackage: {
              type: 'object',
              properties: {
                package_id: { type: 'number' },
                package: {
                  type: 'object',
                  properties: { upper_name: { type: 'string' } },
                  required: ['upper_name'],
                },
                pkg: {
                  type: 'object',
                  properties: { upper_name: { type: 'string' } },
                  required: ['upper_name'],
                },
              },
              required: ['package_id'],
            },
            trialPrice: { type: 'string' },
            withTax: { type: 'boolean' },
            with_GST: { type: 'boolean' },
          },
          required: [
            'currency_code',
            'currency_sign',
            'extendPrice',
            'img',
            'isBoth',
            'isEmployer',
            'isFreelancer',
            'price',
            'taxName',
            'trialBenefits',
            'trialPackage',
            'trialPrice',
            'withTax',
            'with_GST',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketMembershipBenefit: {
      type: 'object',
      properties: { benefit_value: { type: 'number' } },
      required: ['benefit_value'],
    },
    WebsocketUserReportsActionBidRestrictionEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['userReportsActionBidRestriction'] },
        data: {
          type: 'object',
          properties: {
            id: { type: 'number' },
            action: { type: 'string' },
            startDate: { type: 'number' },
            endDate: { type: 'number' },
          },
          required: ['action', 'endDate', 'id', 'startDate'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketVerificationRequestEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['verificationRequestRejected'] },
        data: {
          type: 'object',
          properties: {
            verificationFileIds: { type: 'array', items: { type: 'string' } },
          },
          required: ['verificationFileIds'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketWelcomeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['welcome'] },
        data: {
          type: 'object',
          properties: { siteName: { type: 'string' } },
          required: ['siteName'],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketWinningDesignReadyForReviewEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['winningDesignReadyForReview'] },
        data: {
          type: 'object',
          properties: {
            autoReleasePrizeTime: { type: 'number' },
            contest_name: { type: 'string' },
            contest_url: { type: 'string' },
            entry_id: { type: 'string' },
            imgUrl: { type: 'string' },
            winner_name: { type: 'string' },
            winner_profile_url: { type: 'string' },
            winner_publicName: { type: 'string' },
          },
          required: [
            'autoReleasePrizeTime',
            'contest_name',
            'contest_url',
            'entry_id',
            'imgUrl',
            'winner_name',
            'winner_profile_url',
            'winner_publicName',
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketXpContestEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['xpContest'] },
        data: {
          allOf: [
            { $ref: 'defs.json#/definitions/TimeSeconds' },
            {
              type: 'object',
              properties: {
                id: { type: ['string', 'number'] },
                actionText: {},
                appended_descr: { type: 'string' },
                buyer: { type: 'string' },
                buyerUrl: { type: 'string' },
                imgUrl: { type: 'string' },
                isTest: { type: 'boolean' },
                jobs: {
                  anyOf: [
                    { type: 'array', items: { type: 'string' } },
                    { type: 'array', items: { type: 'number' } },
                  ],
                },
                jobString: { type: 'string' },
                linkUrl: { type: 'string' },
                title: { type: 'string' },
                userId: { type: 'string' },
                userName: { type: 'string' },
              },
              required: [
                'actionText',
                'appended_descr',
                'buyer',
                'buyerUrl',
                'id',
                'imgUrl',
                'isTest',
                'jobString',
                'jobs',
                'linkUrl',
                'title',
                'userId',
                'userName',
              ],
            },
            {
              type: 'object',
              properties: {
                currency: { type: 'string' },
                currencyCode: { type: 'string' },
                maxbudget: { type: ['string', 'number'] },
              },
              required: ['currency', 'currencyCode', 'maxbudget'],
            },
          ],
        },
        id: { type: 'string' },
        parent_type: { type: 'string', enum: ['notifications'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketOnlineOfflineSubscribeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['statusget'] },
        data: {
          type: 'object',
          additionalProperties: {
            $ref: 'defs.json#/definitions/OnlineOfflineUserStatusValueApi',
          },
        },
        parent_type: { type: 'string', enum: ['onlineoffline'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
        id: { type: 'string' },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    OnlineOfflineUserStatusValueApi: { enum: [1, 2], type: 'number' },
    WebsocketOnlineOfflineStatusChangeEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['statuschange'] },
        data: {
          type: 'object',
          properties: {
            from: {
              $ref: 'defs.json#/definitions/OnlineOfflineUserStatusValueApi',
            },
            timestamp: { type: 'number' },
            to: {
              $ref: 'defs.json#/definitions/OnlineOfflineUserStatusValueApi',
            },
            user: { type: 'number' },
          },
          required: ['from', 'timestamp', 'to', 'user'],
        },
        parent_type: { type: 'string', enum: ['onlineoffline'] },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
        id: { type: 'string' },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketNewMessageEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['private'] },
        parent_type: { type: 'string', enum: ['messages'] },
        data: {
          type: 'object',
          properties: {
            attachments: { type: 'array', items: { type: 'string' } },
            client_message_id: { type: 'string' },
            from_user: { type: 'number' },
            id: { type: 'number' },
            message: { type: 'string' },
            message_source: { $ref: 'defs.json#/definitions/SourceTypeApi' },
            notify_user: { type: 'boolean' },
            parent_id: { type: 'number' },
            rich_message: { $ref: 'defs.json#/definitions/RichMessageApi' },
            thread_details: {
              type: 'object',
              properties: {
                context: {
                  type: 'object',
                  properties: {
                    id: { type: 'number' },
                    type: {
                      enum: [
                        'contest',
                        'none',
                        'post',
                        'prehire',
                        'project',
                        'support_chat',
                        'support_session',
                        'team',
                      ],
                      type: 'string',
                    },
                  },
                },
                creator_id: { type: 'number' },
                members: { type: 'array', items: { type: 'number' } },
                thread_type: { $ref: 'defs.json#/definitions/ThreadType' },
              },
              required: ['context', 'creator_id', 'members', 'thread_type'],
            },
            thread_id: { type: 'number' },
            time_created: { type: 'number' },
          },
          required: [
            'attachments',
            'from_user',
            'id',
            'message',
            'message_source',
            'notify_user',
            'parent_id',
            'thread_details',
            'thread_id',
            'time_created',
          ],
        },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
        id: { type: 'string' },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    ThreadType: {
      enum: [
        'admin_preferred_chat',
        'group',
        'pcb',
        'primary',
        'private_chat',
        'support_chat',
        'team',
        'team_official',
      ],
      type: 'string',
    },
    WebsocketThreadWritePrivacyUpdateEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['write_privacy_update'] },
        parent_type: { type: 'string', enum: ['messages'] },
        data: {
          type: 'object',
          properties: {
            thread_ids: { type: 'array', items: { type: 'number' } },
            write_privacy: { $ref: 'defs.json#/definitions/PrivacyLevelApi' },
          },
          required: ['thread_ids', 'write_privacy'],
        },
      },
      required: ['data', 'parent_type', 'type'],
    },
    PrivacyLevelApi: {
      enum: ['all', 'members', 'mine', 'none', 'owner', 'owner_autochat'],
      type: 'string',
    },
    WebsocketTypingEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['typing'] },
        parent_type: { type: 'string', enum: ['messages'] },
        data: {
          type: 'object',
          properties: {
            from_user: { type: 'number' },
            thread: { type: 'number' },
          },
          required: ['from_user', 'thread'],
        },
      },
      required: ['data', 'parent_type', 'type'],
    },
    WebsocketUserReadEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['user_read'] },
        parent_type: { type: 'string', enum: ['messages'] },
        data: {
          type: 'object',
          properties: {
            id: { type: ['string', 'number'] },
            thread_ids: { type: 'array', items: { type: 'number' } },
            user_id: { type: 'number' },
          },
          required: ['id', 'thread_ids', 'user_id'],
        },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
        id: { type: 'string' },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketUserAttachEvent: {
      type: 'object',
      properties: {
        type: { type: 'string', enum: ['attach'] },
        parent_type: { type: 'string', enum: ['messages'] },
        data: {
          type: 'object',
          properties: {
            filenames: { type: 'array', items: { type: 'string' } },
            from_user: { type: 'number' },
            message_id: { type: 'number' },
            thread_id: { type: 'number' },
            time_created: { type: 'number' },
            attachments: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  attachment_id: { type: 'number' },
                  filename: { type: 'string' },
                },
                required: ['attachment_id', 'filename'],
              },
            },
          },
          required: [
            'attachments',
            'filenames',
            'from_user',
            'message_id',
            'thread_id',
            'time_created',
          ],
        },
        id: { type: 'string' },
        timestamp: {
          description: 'A timestamp in seconds: 500_000_000 - 5_000_000_000',
          minimum: 500000000,
          maximum: 5000000000,
          type: 'number',
        },
      },
      required: ['data', 'id', 'parent_type', 'timestamp', 'type'],
    },
    WebsocketVideoEvent: {
      type: 'object',
      properties: {
        type: {
          enum: [
            'video:accept',
            'video:close',
            'video:reject',
            'video:request',
            'video:request:audio_only',
          ],
          type: 'string',
        },
        parent_type: { type: 'string', enum: ['messages'] },
        data: {
          type: 'object',
          properties: {
            session_id: { type: 'string' },
            thread_id: { type: 'number' },
            user_id: { type: 'number' },
          },
          required: ['session_id', 'thread_id', 'user_id'],
        },
      },
      required: ['data', 'parent_type', 'type'],
    },
    ArrowPostJobFormState: {
      description:
        'This is to store the state of the AFLN PJP form state in order to save as a draft. The fields have `null`\nbecause when you call `.reset()` on the form group, the form controls in it are all set to `null`\nas the default value unless overridden.',
      type: 'object',
      properties: {
        ownershipType: {
          anyOf: [
            { enum: ['otherUser', 'self'], type: 'string' },
            { type: 'null' },
          ],
        },
        ownershipUser: { type: ['null', 'string'] },
        ownershipHasPartner: { type: ['null', 'boolean'] },
        ownershipPartner: { type: ['null', 'string'] },
        title: { type: ['null', 'string'] },
        description: { type: ['null', 'string'] },
        ndaHiddenDescription: { type: ['null', 'string'] },
        skills: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/Skill' },
        },
        hasDeadline: { type: 'boolean' },
        startDate: {
          description:
            'Enables basic storage and retrieval of dates and times.',
          type: 'string',
          format: 'date-time',
        },
        completionDate: {
          anyOf: [
            {
              description:
                'Enables basic storage and retrieval of dates and times.',
              type: 'string',
              format: 'date-time',
            },
            { type: 'null' },
          ],
        },
        audience: { type: ['null', 'string'] },
        budgetType: { type: ['null', 'string'] },
        currencyId: { type: 'number' },
        budget: {
          anyOf: [
            {
              type: 'object',
              properties: {
                minimum: { type: ['null', 'number'] },
                maximum: { type: ['null', 'number'] },
              },
              required: ['minimum'],
            },
            { type: ['null', 'string'] },
          ],
        },
        customBudget: {
          type: 'object',
          properties: {
            minimum: { type: ['null', 'string', 'number'] },
            maximum: { type: ['null', 'string', 'number'] },
          },
          required: ['maximum', 'minimum'],
        },
        upgrades: { type: 'object', additionalProperties: { type: 'boolean' } },
      },
      required: [
        'budget',
        'budgetType',
        'currencyId',
        'description',
        'hasDeadline',
        'ndaHiddenDescription',
        'skills',
        'title',
        'upgrades',
      ],
    },
    Skill: {
      description:
        'A skill possessed by a freelancer, and required by projects to allow bidding.\n\nTODO T72831: Confusingly the API calls this a Job, conflicting with the Post\nJob Page which posts a project or contest, among others.',
      type: 'object',
      properties: {
        id: { type: 'number' },
        name: { type: 'string' },
        category: { $ref: 'defs.json#/definitions/Category' },
        local: { type: 'boolean' },
        seoUrl: { type: 'string' },
        activeProjectCount: { type: 'number' },
      },
      required: ['activeProjectCount', 'id', 'local', 'name', 'seoUrl'],
    },
    Category: {
      type: 'object',
      properties: { id: { type: 'number' }, name: { type: 'string' } },
      required: ['id'],
    },
    DevelopersPreference: {
      type: 'object',
      properties: {
        language: { type: 'string', enum: ['bash'] },
        environment: { $ref: 'defs.json#/definitions/DeveloperEnvironment' },
      },
      required: ['environment', 'language'],
    },
    DeveloperEnvironment: {
      enum: ['Dev', 'Production', 'Sandbox', 'Staging'],
      type: 'string',
    },
    ProjectViewProject: {
      description:
        'A project.\nUsed on the Freelancer Project View Page.\n\nProjections: `attachment_details`, `full_description`, `job_details`,\n`location_details`, `qualification_details`, `upgrade_details`,\n`nda_details`, `project_collaboration_details`, `upgrade_details`,\n`review_availability_details`, `local_details`, `equipment`',
      type: 'object',
      properties: {
        attachments: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectAttachment' },
        },
        canPostReview: { $ref: 'defs.json#/definitions/ReviewAvailabilityApi' },
        description: { type: 'string' },
        skills: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/Skill' },
        },
        location: { $ref: 'defs.json#/definitions/Location' },
        true_location: { $ref: 'defs.json#/definitions/Location' },
        ndaDetails: { $ref: 'defs.json#/definitions/NDADetails' },
        qualifications: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/Qualification' },
        },
        displayLocation: { type: 'string' },
        localDetails: { $ref: 'defs.json#/definitions/ProjectLocalDetails' },
        equipment: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/EquipmentApi' },
        },
        invitedFreelancers: { type: 'array', items: { type: 'number' } },
        bidPeriod: { type: 'number' },
        bidStats: { $ref: 'defs.json#/definitions/ProjectBidStats' },
        budget: { $ref: 'defs.json#/definitions/ProjectBudget' },
        currency: { $ref: 'defs.json#/definitions/Currency' },
        deleted: { type: 'boolean' },
        frontendProjectStatus: {
          description:
            'WARNING: Do not rely on this in tests or in the app. It can be broken for projects\nthat move backwards in the project flow at any point (e.g. cancelled then reawarded),\nand multi-award. Use ProjectStatusHelper instead.',
          enum: ['complete', 'draft', 'open', 'pending', 'work_in_progress'],
          type: 'string',
        },
        hideBids: { type: 'boolean' },
        hireme: { type: 'boolean' },
        hiremeInitialBid: { $ref: 'defs.json#/definitions/HireMeInitialBid' },
        hourlyProjectInfo: {
          $ref: 'defs.json#/definitions/ProjectHourlyProjectInfo',
        },
        id: { type: 'number' },
        language: { type: 'string' },
        local: { type: 'boolean' },
        ownerId: { type: 'number' },
        previewDescription: { type: 'string' },
        projectCollaborations: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectCollaborations' },
        },
        seoUrl: { type: 'string' },
        status: { $ref: 'defs.json#/definitions/ProjectStatusApi' },
        subStatus: {
          description:
            "ProjectSubStatusApi.FROZEN_AWARDED - Waiting for response on award, frozen\nProjectSubStatusApi.CLOSED_AWARDED - Awarded by employer for any freelancer, revoke doesn't count\nProjectSubStatusApi.CANCEL_SELLER - User marks it as incomplete",
          enum: [
            'cancel_admin',
            'cancel_buyer',
            'cancel_seller',
            'closed_awarded',
            'closed_expired',
            'frozen_awarded',
            'frozen_timeout',
          ],
          type: 'string',
        },
        timeSubmitted: { type: 'number' },
        title: { type: 'string' },
        type: { $ref: 'defs.json#/definitions/ProjectTypeApi' },
        upgrades: { $ref: 'defs.json#/definitions/ProjectUpgrades' },
        poolIds: {
          type: 'array',
          items: {
            enum: [
              'api_e2e',
              'arrow_private',
              'deloitte_dc',
              'facebook',
              'flnltd',
              'freelancer',
              'nokia',
            ],
            type: 'string',
          },
        },
        enterpriseIds: { type: 'array', items: { type: 'number' } },
        deloitteDetails: {
          $ref: 'defs.json#/definitions/DeloitteProjectDetails',
        },
        timeframe: { $ref: 'defs.json#/definitions/ProjectTimeframe' },
        isEscrowProject: { type: 'boolean' },
        isSellerKycRequired: { type: 'boolean' },
        isBuyerKycRequired: { type: 'boolean' },
        isDeloitteProject: { type: 'boolean' },
        isTokenProject: { type: 'boolean' },
        isArrowProject: { type: 'boolean' },
        selectedBids: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/Bid' },
        },
        files: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/ProjectFileApi' },
        },
        billingCode: { type: 'string' },
      },
      required: [
        'attachments',
        'bidStats',
        'budget',
        'canPostReview',
        'currency',
        'deleted',
        'hideBids',
        'hireme',
        'id',
        'isBuyerKycRequired',
        'isDeloitteProject',
        'isEscrowProject',
        'isSellerKycRequired',
        'isTokenProject',
        'language',
        'local',
        'ndaDetails',
        'ownerId',
        'previewDescription',
        'projectCollaborations',
        'qualifications',
        'selectedBids',
        'seoUrl',
        'skills',
        'status',
        'timeSubmitted',
        'title',
        'type',
        'upgrades',
      ],
    },
    ProjectAttachment: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        accessHash: { type: 'string' },
        contentType: { type: 'string' },
        filename: { type: 'string' },
        timeSubmitted: { type: 'number' },
        url: { type: 'string' },
      },
      required: ['id'],
    },
    Location: {
      description:
        "A project's location details.\nUsed on the Project View Page and User Profiles",
      type: 'object',
      properties: {
        country: { $ref: 'defs.json#/definitions/Country' },
        city: { type: 'string' },
        mapCoordinates: { $ref: 'defs.json#/definitions/MapCoordinates' },
        vicinity: { type: 'string' },
        administrativeArea: { type: 'string' },
        fullAddress: { type: 'string' },
      },
    },
    Country: {
      description: 'A country.',
      type: 'object',
      properties: {
        id: { type: 'string' },
        code: { type: 'string' },
        name: { type: 'string' },
        phoneCode: {
          description: 'only present when fetching the `countries` collection',
          type: 'number',
        },
        flagUrl: {
          description:
            "only present when fetching a user's location, e.g. `projectViewUsers`",
          type: 'string',
        },
      },
      required: ['code', 'id', 'name'],
    },
    MapCoordinates: {
      type: 'object',
      properties: {
        latitude: { type: 'number' },
        longitude: { type: 'number' },
      },
      required: ['latitude', 'longitude'],
    },
    NDADetails: {
      type: 'object',
      properties: {
        hiddenDescription: { type: 'string' },
        signatures: {
          type: 'array',
          items: { $ref: 'defs.json#/definitions/NDASignature' },
        },
      },
      required: ['signatures'],
    },
    NDASignature: {
      type: 'object',
      properties: {
        timeSigned: { type: 'number' },
        projectId: { type: 'number' },
        userId: { type: 'number' },
      },
      required: ['projectId', 'timeSigned', 'userId'],
    },
    Qualification: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        description: { type: 'string' },
        iconName: { type: 'string' },
        iconUrl: { type: 'string' },
        level: { type: 'number' },
        name: { type: 'string' },
        scorePercentage: { type: 'number' },
        type: { type: 'string' },
        userPercentile: { type: 'number' },
      },
    },
    ProjectLocalDetails: {
      type: 'object',
      properties: {
        date: { $ref: 'defs.json#/definitions/ProjectLocalDetailsDateApi' },
        dateTimestamp: { type: 'number' },
        endLocation: { $ref: 'defs.json#/definitions/Location' },
        displayEndLocation: { type: 'string' },
      },
    },
    ProjectBidStats: {
      type: 'object',
      properties: { bidCount: { type: 'number' }, bidAvg: { type: 'number' } },
      required: ['bidCount'],
    },
    ProjectBudget: {
      type: 'object',
      properties: {
        minimum: { type: 'number' },
        maximum: { type: 'number' },
        name: { type: 'string' },
        projectType: { enum: ['fixed', 'hourly'], type: 'string' },
        currencyId: { type: 'number' },
      },
      required: ['minimum'],
    },
    Currency: {
      description:
        'A supported currency, pulled from the API.\nSee `currenciesIncludingExternal` for the projection that includes external currencies.',
      type: 'object',
      properties: {
        code: { type: 'string' },
        country: { type: 'string' },
        id: { type: 'number' },
        name: { type: 'string' },
        sign: { type: 'string' },
        isExternal: { type: 'boolean' },
        exchangeRate: { type: 'number' },
      },
      required: ['code', 'id', 'sign'],
    },
    HireMeInitialBid: {
      type: 'object',
      properties: {
        bidderId: { type: 'number' },
        amount: { type: 'number' },
        period: { type: 'number' },
      },
      required: ['amount', 'bidderId', 'period'],
    },
    ProjectHourlyProjectInfo: {
      type: 'object',
      properties: {
        commitment: { $ref: 'defs.json#/definitions/CommitmentApi' },
        durationEnum: {
          enum: [
            'less_than_one_week',
            'one_to_four_weeks',
            'one_to_three_months',
            'ongoing',
            'three_to_six_months',
            'unknown',
            'unspecified',
          ],
          type: 'string',
        },
      },
    },
    ProjectCollaborations: {
      type: 'object',
      properties: {
        context: { $ref: 'defs.json#/definitions/Context' },
        contextOwnerId: { type: 'number' },
        id: { type: 'number' },
        inviteToken: { type: 'string' },
        permissions: {
          type: 'array',
          items: {
            enum: [
              'bid_award',
              'chat',
              'collaborator_add',
              'dispute_create',
              'file_upload',
              'milestone_create',
              'milestone_release',
              'milestone_request',
              'milestone_view',
              'project_details_edit',
              'task_list_edit',
              'tracked_hours_approve',
              'unknown',
            ],
            type: 'string',
          },
        },
        status: {
          enum: [
            'accept_pending',
            'active',
            'inactive',
            'signup_pending',
            'unknown',
          ],
          type: 'string',
        },
        timeCreated: { type: 'number' },
        timeUpdated: { type: 'number' },
        userId: { type: 'number' },
      },
      required: ['id', 'permissions'],
    },
    Context: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        type: { $ref: 'defs.json#/definitions/ContextTypeApi' },
      },
      required: ['id', 'type'],
    },
    ProjectTypeApi: { enum: ['fixed', 'hourly'], type: 'string' },
    ProjectUpgrades: {
      type: 'object',
      properties: {
        assisted: { type: 'boolean' },
        featured: { type: 'boolean' },
        fulltime: { type: 'boolean' },
        ipContract: { type: 'boolean' },
        listed: { type: 'boolean' },
        NDA: { type: 'boolean' },
        nonpublic: { type: 'boolean' },
        projectManagement: { type: 'boolean' },
        qualified: { type: 'boolean' },
        sealed: { type: 'boolean' },
        urgent: { type: 'boolean' },
        extend: { type: 'boolean' },
        unpaidRecruiter: { type: 'boolean' },
        pfOnly: { type: 'boolean' },
      },
      required: [
        'NDA',
        'assisted',
        'extend',
        'featured',
        'fulltime',
        'ipContract',
        'listed',
        'nonpublic',
        'projectManagement',
        'qualified',
        'sealed',
        'urgent',
      ],
    },
    DeloitteProjectDetails: {
      description: 'Deloitte project details found in a Deloitte project',
      type: 'object',
      properties: {
        billingCode: { type: 'string' },
        industryOffering: {
          $ref: 'defs.json#/definitions/DeloitteIndustryOffering',
        },
        clearance: { type: ['null', 'string'] },
        itar: { type: ['null', 'boolean'] },
      },
      required: ['billingCode', 'clearance', 'industryOffering', 'itar'],
    },
    DeloitteIndustryOffering: {
      type: 'object',
      properties: {
        projectType: { $ref: 'defs.json#/definitions/DeloitteProjectTypeApi' },
        practice: { $ref: 'defs.json#/definitions/DeloittePracticeApi' },
        industry: { $ref: 'defs.json#/definitions/DeloitteIndustryApi' },
        offering: { $ref: 'defs.json#/definitions/DeloitteOfferingApi' },
      },
      required: ['industry', 'offering', 'practice', 'projectType'],
    },
    ProjectTimeframe: {
      type: 'object',
      properties: {
        startDate: { type: 'number' },
        endDate: { type: 'number' },
      },
    },
    Bid: {
      description: 'A bid placed on a project.',
      type: 'object',
      properties: {
        id: { type: 'number' },
        bidderId: { type: 'number' },
        projectId: { type: 'number' },
        retracted: { type: 'boolean' },
        amount: { type: 'number' },
        period: { type: 'number' },
        description: { type: 'string' },
        projectOwnerId: { type: 'number' },
        submitDate: { type: 'number' },
        buyerProjectFee: { $ref: 'defs.json#/definitions/Fee' },
        timeSubmitted: { type: 'number' },
        highlighted: { type: 'boolean' },
        sponsored: { type: 'number' },
        milestonePercentage: { type: 'number' },
        awardStatusPossibilities: {
          type: 'array',
          items: {
            enum: ['awarded', 'canceled', 'pending', 'rejected', 'revoked'],
            type: 'string',
          },
        },
        awardStatus: {
          enum: ['awarded', 'canceled', 'pending', 'rejected', 'revoked'],
          type: 'string',
        },
        paidStatus: {
          enum: ['fully_paid', 'partly_paid', 'unpaid'],
          type: 'string',
        },
        completeStatus: {
          enum: ['complete', 'incomplete', 'pending'],
          type: 'string',
        },
        timeAwarded: { type: 'number' },
        frontendBidStatus: {
          enum: ['active', 'complete', 'in_progress'],
          type: 'string',
        },
        shortlisted: { type: 'boolean' },
        score: { type: 'number' },
        distance: { type: 'number' },
        negotiatedOffer: { $ref: 'defs.json#/definitions/NegotiatedOfferApi' },
        hidden: { type: 'boolean' },
        hiddenReason: {
          enum: [
            'advertising',
            'contacts',
            'fake',
            'harassment',
            'not_interesting',
          ],
          type: 'string',
        },
        timeAccepted: { type: 'number' },
        paidAmount: { type: 'number' },
        hourlyRate: { type: 'number' },
        isLocationTracked: { type: 'boolean' },
        awardExpireTime: {
          description: '36 hours after bid is awarded',
          type: 'number',
        },
        extraForUpdate: { $ref: 'defs.json#/definitions/BidAwardExtraFields' },
        sealed: { type: 'boolean' },
        completeStatusChangedTime: { type: 'number' },
        awardStatusChangedTime: { type: 'number' },
        rejectReasonCode: {
          enum: [
            'both_budget',
            'employer_nomilestone',
            'employer_spam',
            'employer_unclear',
            'freelancer_enoughwork',
            'freelancer_noskills',
            'freelancer_notime',
            'other',
          ],
          type: 'string',
        },
        otherFeedback: { type: 'string' },
        rating: { $ref: 'defs.json#/definitions/BidRating' },
      },
      required: [
        'amount',
        'bidderId',
        'id',
        'period',
        'projectId',
        'submitDate',
      ],
    },
    Fee: {
      type: 'object',
      properties: {
        amount: { type: 'number' },
        is_taxed: { type: 'boolean' },
        currency: { $ref: 'defs.json#/definitions/Currency' },
        rate: { type: 'number' },
        rate_with_tax: { type: 'number' },
      },
      required: ['amount', 'is_taxed'],
    },
    BidAwardExtraFields: {
      type: 'object',
      properties: {
        workLimit: { type: 'number' },
        billingCycle: { enum: ['monthly', 'weekly'], type: 'string' },
        skipHourlyContract: { type: 'boolean' },
      },
    },
    BidRating: {
      description:
        'Bids can be rated by employers, and this information is represented\nin this interface.\n\nBid ratings will primarily be fetched and updated on the Proposals tab\nof the Project View page',
      type: 'object',
      properties: {
        authorId: { type: 'number' },
        bidId: { type: 'number' },
        comment: { type: 'string' },
        id: { type: 'number' },
        rating: { type: 'number' },
        timeCreated: { type: 'number' },
        timeUpdated: { type: 'number' },
      },
      required: ['authorId', 'bidId', 'id', 'rating'],
    },
    FocusState: { enum: [0, 1, 2], type: 'number' },
    ThreadIdentifier: {
      type: 'object',
      properties: {
        id: { type: 'number' },
        threadType: { $ref: 'defs.json#/definitions/ThreadType' },
        context: {
          anyOf: [
            {
              type: 'object',
              properties: {
                type: { $ref: 'defs.json#/definitions/ThreadContextType' },
                id: { type: 'number' },
              },
              required: ['id', 'type'],
            },
            {
              type: 'object',
              properties: { type: { type: 'string', enum: ['none'] } },
              required: ['type'],
            },
          ],
        },
        members: { type: 'array', items: { type: 'number' } },
        isFake: { type: 'boolean' },
      },
      required: ['context', 'id', 'isFake', 'members', 'threadType'],
    },
    ThreadContextType: {
      enum: [
        'contest',
        'prehire',
        'project',
        'support_chat',
        'support_session',
        'team',
      ],
      type: 'string',
    },
    DraftMessage: {
      type: 'object',
      properties: { text: { type: 'string' }, lastUpdated: { type: 'number' } },
      required: ['lastUpdated', 'text'],
    },
    TaskListState: {
      type: 'object',
      properties: {
        currentTaskClean: { type: 'boolean' },
        draftTask: {
          anyOf: [
            { $ref: 'defs.json#/definitions/Task' },
            { $ref: 'defs.json#/definitions/Partial<Task>' },
          ],
        },
      },
    },
    Task: {
      description: "A task on a project's task list.",
      type: 'object',
      properties: {
        id: { type: 'number' },
        ownerId: { type: 'number' },
        createTime: { type: 'number' },
        source: { $ref: 'defs.json#/definitions/TaskSourceApi' },
        status: { $ref: 'defs.json#/definitions/TaskStatusApi' },
        list: { type: 'string', enum: ['default_list'] },
        assigneeId: { type: 'number' },
        dueDate: { type: 'number' },
        title: { type: 'string' },
        description: { type: 'string' },
      },
      required: ['createTime', 'id', 'list', 'ownerId', 'source', 'status'],
    },
    'Partial<Task>': {
      type: 'object',
      properties: {
        id: { type: 'number' },
        ownerId: { type: 'number' },
        createTime: { type: 'number' },
        source: { $ref: 'defs.json#/definitions/TaskSourceApi' },
        status: {
          enum: ['closed_deleted', 'closed_resolved', 'in_progress'],
          type: 'string',
        },
        list: { enum: ['default_list'], type: 'string' },
        assigneeId: { type: 'number' },
        dueDate: { type: 'number' },
        title: { type: 'string' },
        description: { type: 'string' },
      },
    },
    LastSeenPjpAssistant: {
      type: 'object',
      properties: { time: { type: 'number' } },
      required: ['time'],
    },
    HireMeDraft: {
      type: 'object',
      properties: {
        budget: { type: 'number' },
        currencyId: { type: 'number' },
        freelancerId: { type: 'number' },
        hireFor: { type: 'string' },
        hoursPerWeek: { type: 'number' },
        message: { type: 'string' },
        confirmed: { type: 'boolean' },
      },
      required: [
        'budget',
        'currencyId',
        'freelancerId',
        'hireFor',
        'hoursPerWeek',
        'message',
      ],
    },
    PostJobPageFormState: {
      description:
        "This stores the value of the fields in PJP which can be saved as a draft.\nIt consist of fields for both Projects and Contests. In the DB, this is\nstored as a stringified JSON in the `draft` table.\n\nNote that all fields are nullable except for the id, title, and description.\nAn id is required for the documents that we keep in the datastore. Also, we\nonly begin saving drafts when there's a title and description.\n\nAdditionally, the reason for choosing `null` over `undefined` is that the\nfield whose value is `undefined` gets removed from the resulting string when\nwe `JSON.stringify` the object. We want to avoid having inconsistent format\nin the DB so we used `null` instead.\n\nThere is also an inconsistent type for contestUpgrades where it initially\ncontains `ContestUpgrade`. When the contest type card is selected, it now\ncontains an array of selected upgrades (T92144).\n\nLastly, the corresponding type of the following fields are currently defined\nin `JobPostModule`. In order to declare the types properly, we must move\nthe definitions to a model file so that they can be imported here (T92109):\n- contestDurationType: DurationType\n- jobType: JobType\n- projectBudgetType: BudgetType",
      type: 'object',
      properties: {
        communitySelection: {
          enum: ['facebook', 'freelancer'],
          type: 'string',
        },
        contestDuration: { type: ['null', 'number'] },
        contestDurationType: { type: ['null', 'string'] },
        contestPrize: { type: ['null', 'number'] },
        contestType: {
          anyOf: [
            { enum: ['basic', 'guaranteed'], type: 'string' },
            { type: 'null' },
          ],
        },
        currencyId: { type: ['null', 'number'] },
        description: { type: 'string' },
        hasBillingCode: { type: ['null', 'boolean'] },
        billingCode: { type: ['null', 'string'] },
        audience: {
          anyOf: [
            { enum: ['flnltd', 'flnltd_and_marketplace'], type: 'string' },
            { type: 'null' },
          ],
        },
        id: { type: 'number' },
        isLocal: { type: ['null', 'boolean'] },
        jobType: { type: ['null', 'string'] },
        projectBudgetRange: {
          anyOf: [
            { $ref: 'defs.json#/definitions/ProjectBudgetOption' },
            { type: 'null' },
          ],
        },
        projectBudgetType: { type: ['null', 'string'] },
        projectType: {
          anyOf: [
            { enum: ['recruiter', 'standard'], type: 'string' },
            { type: 'null' },
          ],
        },
        skills: {
          anyOf: [
            { type: 'array', items: { $ref: 'defs.json#/definitions/Skill' } },
            { type: 'null' },
          ],
        },
        submitDate: { type: ['null', 'number'] },
        templateSelection: {
          enum: [
            'advanced-matching',
            'facebook-pixel',
            'facebook-pixel-and-catalog',
            'other',
          ],
          type: 'string',
        },
        title: { type: 'string' },
        userId: { type: 'number' },
      },
      required: [
        'contestDuration',
        'contestDurationType',
        'contestPrize',
        'contestType',
        'currencyId',
        'description',
        'id',
        'isLocal',
        'jobType',
        'projectBudgetRange',
        'projectBudgetType',
        'projectType',
        'skills',
        'submitDate',
        'title',
        'userId',
      ],
    },
    ProjectBudgetOption: {
      description:
        'A budget range for a project.\nPulled from the Projects API.',
      type: 'object',
      properties: {
        id: { type: 'string' },
        minimum: { type: 'number' },
        maximum: { type: 'number' },
        name: { type: 'string' },
        projectType: { $ref: 'defs.json#/definitions/ProjectTypeApi' },
        currencyId: { type: 'number' },
        language: { type: 'string' },
      },
      required: ['currencyId', 'id', 'minimum', 'name', 'projectType'],
    },
    ManageRecentTable: {
      description:
        'Interface used for remembering recently viewed tables in /manage',
      type: 'object',
      properties: {
        employerTable: { type: 'string' },
        freelancerTable: { type: 'string' },
        manageTable: { type: 'string' },
      },
      required: ['employerTable', 'freelancerTable'],
    },
    MockProfile: {
      type: 'object',
      properties: { id: { type: 'number' }, name: { type: 'string' } },
      required: ['id', 'name'],
    },
  },
};
